class MainProductComponent extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.mainEl = this.querySelector('.main-product__main-swiper');
    this.thumbsEl = this.querySelector('.main-product__thumbs-swiper');
    this.thumbSlides = Array.from(this.querySelectorAll('.main-product__thumb-slide'));
    this.breakpoint = Number.parseInt(this.dataset.breakpoint, 10) || 989;
    this.quantityInput = this.querySelector('[data-quantity-input]');
    this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
    this.variantIdInput = this.querySelector('input[name="id"]');
    this.productForm = this.querySelector('.main-product__form');
    this.frequencySelector = this.querySelector('[data-frequency-selector]');
    this.oneTimeButton = this.querySelector('.main-product-form-block__frequency-button[data-frequency="one-time"]');
    this.subscriptionButton = this.querySelector('.main-product-form-block__frequency-button[data-frequency="subscription"]');
    this.ctaButton = this.querySelector('[data-cta-button]');
    this.timerEl = this.querySelector('[data-main-product-timer]');
    this.timerCountdown = this.querySelector('[data-timer-countdown]');
    this.timerValue = this.querySelector('[data-timer-value]');
    this.timerMessage = this.querySelector('[data-timer-message]');
    this.timerInterval = null;
    this.cutoffTime = null;
    this.timerTimezone = this.timerEl?.dataset?.timezone || 'UTC';
    this.stickyBar = null;
    this.stickyCtaButton = null;
    this.stickyTimerEl = null;
    this.stickyTimerCountdown = null;
    this.stickyTimerValue = null;
    this.stickyTimerMessage = null;
    this.stickySummary = null;
    this.stickySummaryImage = null;
    this.stickySummarySubtext = null;
    this.stickyBundleItemsWrap = null;
    this.stickyBundleItems = null;
    this.stickyBundleMobile = null;
    this.stickyBundleTotal = null;
    this.stickyBundleMobileTitle = null;
    this.stickyBundleMobilePrice = null;
    this.stickyBundleCloseButton = null;
    this.stickyBundleToggleButton = null;
    this.stickyBundlePanel = null;
    this.stickyBundleList = null;
    this.stickyBundleProgressHost = null;
    this.stickyBundleCloseTimeout = null;
    this.stickyObservedElement = null;
    this.isStickyBundlePanelOpen = false;
    this.bundleProgressOriginalParent = null;
    this.bundleProgressOriginalNextSibling = null;
    this.stickyObserver = null;
    this.isStickyVisible = false;
    this.stickyScrollReady = false;
    this.drawer = this.querySelector('[data-drawer]');
    this.drawerPanel = this.drawer?.querySelector('[data-drawer-panel]');
    this.packDrawer = this.querySelector('[data-pack-drawer]');
    this.packDrawerPanel = this.packDrawer?.querySelector('[data-pack-drawer-panel]');
    this.packDrawerContent = this.packDrawer?.querySelector('.main-product__drawer-content');
    this.packForm = this.querySelector('[data-pack-form]');
    this.packModalView = this.packForm?.dataset?.packModalView || 'w-pack-modal';
    this.packModalCache = {};
    this.activePackHandle = '';
    this.packProductsData = [];
    this.packOptions = [];
    this.packSelect = null;
    this.packSelectTrigger = null;
    this.packSelectList = null;
    this.packSelectLabel = null;
    this.packSelectImage = null;
    this.packQuantityButtons = [];
    this.packList = null;
    this.packEmpty = null;
    this.packTemplates = [];
    this.packSelectedFormat = '';
    this.packSelectedProductId = '';
    this.packDescriptionTargets = Array.from(this.querySelectorAll('[data-pack-description-content]'));
    this.packDescriptionDefaultHTML = this.packDescriptionTargets[0]?.innerHTML || '';
    this.packIngredientsTargets = Array.from(this.querySelectorAll('[data-pack-ingredients-content]'));
    this.packIngredientsDefaultHTML = this.packIngredientsTargets[0]?.innerHTML || '';
    this.packQuantityBadgeFirst = '';
    this.packQuantityBadgeSecond = '';
    this.bundleForm = this.querySelector('[data-bundle-form]');
    this.bundleTabs = [];
    this.bundleCards = [];
    this.bundleGrid = null;
    this.bundleShowMoreButton = null;
    this.bundleSelectedCount = null;
    this.bundleSelectedSummary = null;
    this.bundleSelectedList = null;
    this.bundleEmptyMessage = null;
    this.bundleHeadingPriceCompare = null;
    this.bundleHeadingPrice = null;
    this.bundleMinProducts = 4;
    this.bundleInitialLimit = 8;
    this.bundleShowMoreLabel = 'Afficher plus de produits';
    this.bundleShowLessLabel = 'Afficher moins de produits';
    this.bundleActiveFilter = 'all';
    this.bundleExpanded = false;
    this.bundleSelections = [];
    this.bundleSelectedProductIds = [];
    this.bundleSubmitPending = false;
    this.bundleSyncFromCart = false;
    this.lastCartBundleItems = [];
    this.onCartChange = this.onCartChange.bind(this);
    this.bundleProgressItems = [];
    this.selectedSubscriptionPlanId = '';
    this.bundleProgressStickyTargets = [];
    this.bundleProgressStickyListening = false;
    this.bundleProgressStickyTicking = false;
    this.videoModal = null;
    this.videoModalDialog = null;
    this.videoModalPlayer = null;
    this.videoModalActiveVideo = null;
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.onThumbClick = this.onThumbClick.bind(this);
    this.onMainSlideChange = this.onMainSlideChange.bind(this);
    this.onComponentClick = this.onComponentClick.bind(this);
    this.onAccordionToggle = this.onAccordionToggle.bind(this);
    this.onAccordionClick = this.onAccordionClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onBundleProgressExternalUpdate = this.onBundleProgressExternalUpdate.bind(this);
    this.onBundleProgressStickyScroll = this.onBundleProgressStickyScroll.bind(this);
    this.onBundleProgressStickyResize = this.onBundleProgressStickyResize.bind(this);
    this.onStickyIntersection = this.onStickyIntersection.bind(this);

    this.addEventListener('click', this.onComponentClick);
    this.addEventListener('main-product:bundle-progress-update', this.onBundleProgressExternalUpdate);
    if (this.productForm) {
      this.productForm.addEventListener('submit', this.onFormSubmit);
    }
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('theme:cart:change', this.onCartChange);
    this.initAccordions();
    this.initStickyForm();
    this.syncFormProductInputs();
    this.initBundleProgress();
    this.initBundleBuilder();
    this.initTimer();
    this.initVideoModal();

    if (!this.mainEl || !this.thumbsEl || typeof Swiper === 'undefined') return;

    this.thumbsEl.addEventListener('click', this.onThumbClick);
    this.mediaQuery = window.matchMedia(`(min-width: ${this.breakpoint}px)`);
    this.onBreakpointChange(this.mediaQuery);
    this.mediaQuery.addEventListener('change', this.onBreakpointChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onComponentClick);
    this.removeEventListener('main-product:bundle-progress-update', this.onBundleProgressExternalUpdate);
    if (this.productForm) {
      this.productForm.removeEventListener('submit', this.onFormSubmit);
    }
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('theme:cart:change', this.onCartChange);

    if (this.accordions && this.accordions.length) {
      this.accordions.forEach((accordion) => {
        accordion.removeEventListener('toggle', this.onAccordionToggle);
        const summary = accordion.querySelector('.main-product__accordion-summary');
        if (summary) {
          summary.removeEventListener('click', this.onAccordionClick);
        }
      });
    }

    if (this.thumbsEl) {
      this.thumbsEl.removeEventListener('click', this.onThumbClick);
    }

    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
    }

    if (this.stickyBundleCloseTimeout) {
      window.clearTimeout(this.stickyBundleCloseTimeout);
      this.stickyBundleCloseTimeout = null;
    }

    this.destroySwipers();
    this.destroyVideoModal();
    this.teardownBundleProgressStickyState();
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
      this.stickyObserver = null;
    }
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
    this.initialized = false;
  }

  initAccordions() {
    this.accordions = Array.from(this.querySelectorAll('.main-product__accordion'));
    if (!this.accordions.length) return;

    this.accordions.forEach((accordion) => {
      const content = accordion.querySelector('.main-product__accordion-content');
      const summary = accordion.querySelector('.main-product__accordion-summary');
      if (!content) return;
      accordion.addEventListener('toggle', this.onAccordionToggle);
      if (summary) {
        summary.addEventListener('click', this.onAccordionClick);
      }
      if (accordion.hasAttribute('open')) {
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
      }
    });
  }

  onAccordionToggle(event) {
    const accordion = event.target;
    if (!(accordion instanceof HTMLElement)) return;
    const content = accordion.querySelector('.main-product__accordion-content');
    if (!content) return;

    if (accordion.open) {
      content.style.height = `${content.scrollHeight}px`;
    } else {
      content.style.height = `${content.scrollHeight}px`;
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
    }
  }

  onAccordionClick(event) {
    event.preventDefault();
    const summary = event.currentTarget;
    const accordion = summary.closest('.main-product__accordion');
    if (!accordion) return;
    const content = accordion.querySelector('.main-product__accordion-content');
    if (!content) return;

    if (accordion.open) {
      content.style.height = `${content.scrollHeight}px`;
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
      content.addEventListener(
        'transitionend',
        () => {
          accordion.open = false;
        },
        { once: true }
      );
      return;
    }

    this.accordions.forEach((item) => {
      if (item === accordion || !item.open) return;
      const itemContent = item.querySelector('.main-product__accordion-content');
      if (!itemContent) return;
      itemContent.style.height = `${itemContent.scrollHeight}px`;
      requestAnimationFrame(() => {
        itemContent.style.height = '0px';
      });
      itemContent.addEventListener(
        'transitionend',
        () => {
          item.open = false;
        },
        { once: true }
      );
    });

    accordion.open = true;
    const targetHeight = content.scrollHeight;
    content.style.height = '0px';
    requestAnimationFrame(() => {
      content.style.height = `${targetHeight}px`;
    });
    content.addEventListener(
      'transitionend',
      () => {
        content.style.height = 'auto';
      },
      { once: true }
    );
  }

  onComponentClick(event) {
    const drawerOpen = event.target.closest('[data-drawer-open]');
    if (drawerOpen && this.contains(drawerOpen)) {
      this.openDrawer();
      return;
    }

    const drawerClose = event.target.closest('[data-drawer-close]');
    if (drawerClose && this.contains(drawerClose)) {
      this.closeDrawer();
      return;
    }

    const drawerOverlay = event.target.closest('[data-drawer-overlay]');
    if (drawerOverlay && this.contains(drawerOverlay)) {
      this.closeDrawer();
      return;
    }

    const packDrawerOpen = event.target.closest('[data-pack-drawer-open]');
    if (packDrawerOpen && this.contains(packDrawerOpen)) {
      const productHandle = packDrawerOpen.dataset.packProductHandle || '';
      this.openPackDrawer(productHandle);
      return;
    }

    const packDrawerClose = event.target.closest('[data-pack-drawer-close]');
    if (packDrawerClose && this.contains(packDrawerClose)) {
      this.closePackDrawer();
      return;
    }

    const packDrawerOverlay = event.target.closest('[data-pack-drawer-overlay]');
    if (packDrawerOverlay && this.contains(packDrawerOverlay)) {
      this.closePackDrawer();
      return;
    }

    const packAccordionSummary = event.target.closest('.main-product-pack-modal__accordion-summary');
    if (packAccordionSummary && this.packDrawerContent && this.packDrawerContent.contains(packAccordionSummary)) {
      this.handlePackModalAccordionClick(event, packAccordionSummary);
      return;
    }

    const videoModalOverlay = event.target.closest('[data-video-modal-overlay]');
    if (videoModalOverlay && this.contains(videoModalOverlay)) {
      const clickedDialog = event.target.closest('[data-video-modal-dialog]');
      if (!clickedDialog) {
        this.closeVideoModal();
      }
      return;
    }

    const videoCard = event.target.closest('.main-product__video-card');
    if (videoCard && this.contains(videoCard)) {
      this.handleVideoToggle(videoCard);
      return;
    }

    const packTrigger = event.target.closest('[data-pack-select-trigger]');
    if (packTrigger && this.packForm && this.packForm.contains(packTrigger)) {
      this.togglePackSelect();
      return;
    }

    const packOption = event.target.closest('[data-pack-option]');
    if (packOption && this.packForm && this.packForm.contains(packOption)) {
      this.handlePackOption(packOption);
      return;
    }

    const packQuantityButton = event.target.closest('[data-pack-quantity-button]');
    if (packQuantityButton && this.packForm && this.packForm.contains(packQuantityButton)) {
      this.handlePackQuantity(packQuantityButton);
      return;
    }

    const bundleTab = event.target.closest('[data-bundle-tab]');
    if (bundleTab && this.bundleForm && this.bundleForm.contains(bundleTab)) {
      this.handleBundleTab(bundleTab);
      return;
    }

    const bundleShowMore = event.target.closest('[data-bundle-show-more]');
    if (bundleShowMore && this.bundleForm && this.bundleForm.contains(bundleShowMore)) {
      this.toggleBundleShowMore();
      return;
    }

    const bundleAdd = event.target.closest('[data-bundle-add]');
    if (bundleAdd && this.bundleForm && this.bundleForm.contains(bundleAdd)) {
      this.handleBundleAdd(bundleAdd);
      return;
    }

    const bundleMinus = event.target.closest('[data-bundle-minus]');
    if (bundleMinus && this.bundleForm && this.bundleForm.contains(bundleMinus)) {
      this.handleBundleDelta(bundleMinus, -1);
      return;
    }

    const bundlePlus = event.target.closest('[data-bundle-plus]');
    if (bundlePlus && this.bundleForm && this.bundleForm.contains(bundlePlus)) {
      this.handleBundleDelta(bundlePlus, 1);
      return;
    }

    const bundleCard = event.target.closest('[data-bundle-card]');
    if (bundleCard && this.bundleForm && this.bundleForm.contains(bundleCard)) {
      const clickedCardActions = event.target.closest('.main-product-bundle-card__actions');
      if (!clickedCardActions) {
        const productHandle = bundleCard.dataset.bundleProductHandle || '';
        if (productHandle) {
          this.openPackDrawer(productHandle);
          return;
        }
      }
    }

    const stickySubmit = event.target.closest('[data-sticky-submit]');
    if (stickySubmit && this.stickyBar && this.stickyBar.contains(stickySubmit)) {
      event.preventDefault();
      this.handleStickySubmit(stickySubmit);
      return;
    }

    const stickyBundleToggle = event.target.closest('[data-sticky-bundle-toggle]');
    if (stickyBundleToggle && this.stickyBar && this.stickyBar.contains(stickyBundleToggle)) {
      event.preventDefault();
      this.toggleStickyBundlePanel();
      return;
    }

    const stickyBundleClose = event.target.closest('[data-sticky-bundle-close]');
    if (stickyBundleClose && this.stickyBar && this.stickyBar.contains(stickyBundleClose)) {
      event.preventDefault();
      this.closeStickyBundlePanelWithAnimation();
      return;
    }

    const stickyBundleMinus = event.target.closest('[data-sticky-bundle-minus]');
    if (stickyBundleMinus && this.stickyBar && this.stickyBar.contains(stickyBundleMinus)) {
      event.preventDefault();
      this.adjustStickyBundleItemQuantity(stickyBundleMinus.dataset.stickyBundleVariantId, -1);
      return;
    }

    const stickyBundlePlus = event.target.closest('[data-sticky-bundle-plus]');
    if (stickyBundlePlus && this.stickyBar && this.stickyBar.contains(stickyBundlePlus)) {
      event.preventDefault();
      this.adjustStickyBundleItemQuantity(stickyBundlePlus.dataset.stickyBundleVariantId, 1);
      return;
    }

    const quantityButton = event.target.closest('.main-product-form-block__quantity-button');
    if (quantityButton && this.contains(quantityButton)) {
      this.handleQuantitySelection(quantityButton);
      return;
    }

    const subscriptionPlanButton = event.target.closest('.main-product-form-block__subscription-plan-button');
    if (subscriptionPlanButton && this.contains(subscriptionPlanButton)) {
      event.preventDefault();
      this.handleSubscriptionPlanSelection(subscriptionPlanButton);
      return;
    }

    const frequencyButton = event.target.closest('.main-product-form-block__frequency-button');
    if (frequencyButton && this.contains(frequencyButton)) {
      const isSubscriptionButton = frequencyButton.dataset.frequency === 'subscription';
      if (isSubscriptionButton) {
        const clickInsidePlanList = event.target.closest('.main-product-form-block__subscription-plan-list');
        if (!clickInsidePlanList) {
          this.toggleSubscriptionPlans(true);
        }
      } else {
        this.toggleSubscriptionPlans(false);
      }
      this.handleFrequencySelection(frequencyButton);
      return;
    }

    if (this.packSelect && this.packSelect.classList.contains('is-open')) {
      const insideSelect = event.target.closest('[data-pack-select]');
      if (!insideSelect) {
        this.closePackSelect();
      }
    }
  }

  onKeyDown(event) {
    if (event.key !== 'Escape') return;
    if (this.videoModal && this.videoModal.classList.contains('is-open')) {
      this.closeVideoModal();
      return;
    }
    if (this.packDrawer && this.packDrawer.classList.contains('is-open')) {
      this.closePackDrawer();
      return;
    }
    if (this.drawer && this.drawer.classList.contains('is-open')) {
      this.closeDrawer();
    }
  }

  onFormSubmit(event) {
    if (!event || event.defaultPrevented) return;
    if (!this.productForm || event.target !== this.productForm) return;

    const submitter = event.submitter || this.ctaButton || this.productForm.querySelector('[type="submit"]');
    if (!(submitter instanceof HTMLElement)) return;

    // Template bundle : submit custom Recharge puis on recharge / ouvre le side-cart du theme.
    if (this.bundleForm && this.bundleCards?.length) {
      event.preventDefault();

      if (this.bundleSubmitPending) return;
      const totalQty = this.getBundleSelectedQuantity();
      if (!this.isBundleMinimumReached(totalQty)) {
        this.updateCtaBundleState(totalQty);
        return;
      }

      this.submitBundleWithRechargeDynamic()
        .catch((error) => {
          console.error('[MainProduct] Recharge bundle submit error:', error);
        })
        .finally(() => {
          this.setBundleCtaLoading(false);
        });
      return;
    }

    // Templates classique + pack : on laisse le CartDrawer du theme gerer l'ajout AJAX
    // via l'evenement global `theme:cart:add` (mise a jour du side-cart + ouverture).
    event.preventDefault();
    this.syncSellingPlanBeforeSubmit();
    const handledByThemeCart = this.dispatchThemeCartAdd(submitter);

    // Fallback defensif si le CartDrawer du theme n'est pas charge.
    if (!handledByThemeCart && this.productForm instanceof HTMLFormElement) {
      HTMLFormElement.prototype.submit.call(this.productForm);
    }
  }

  initStickyForm() {
    this.stickyBar = this.querySelector('[data-main-product-sticky]');
    if (!this.stickyBar) return;

    this.stickyCtaButton = this.stickyBar.querySelector('[data-sticky-cta]');
    this.stickyTimerEl = this.stickyBar.querySelector('[data-sticky-timer]');
    this.stickyTimerCountdown = this.stickyBar.querySelector('[data-sticky-timer-countdown]');
    this.stickyTimerValue = this.stickyBar.querySelector('[data-sticky-timer-value]');
    this.stickyTimerMessage = this.stickyBar.querySelector('[data-sticky-timer-message]');
    this.stickySummary = this.stickyBar.querySelector('[data-sticky-summary]');
    this.stickySummaryImage = this.stickyBar.querySelector('[data-sticky-summary-image]');
    this.stickySummarySubtext = this.stickyBar.querySelector('[data-sticky-summary-subtext]');
    this.stickyBundleItemsWrap = this.stickyBar.querySelector('[data-sticky-bundle-wrap]');
    this.stickyBundleItems = this.stickyBar.querySelector('[data-sticky-bundle-items]');
    this.stickyBundleMobile = this.stickyBar.querySelector('[data-sticky-bundle-mobile]');
    this.stickyBundleTotal = this.stickyBar.querySelector('[data-sticky-bundle-total]');
    this.stickyBundleMobileTitle = this.stickyBar.querySelector('[data-sticky-bundle-mobile-title]');
    this.stickyBundleMobilePrice = this.stickyBar.querySelector('[data-sticky-bundle-mobile-price]');
    this.stickyBundleCloseButton = this.stickyBar.querySelector('[data-sticky-bundle-close]');
    this.stickyBundleToggleButton = this.stickyBar.querySelector('[data-sticky-bundle-toggle]');
    this.stickyBundlePanel = this.stickyBar.querySelector('[data-sticky-bundle-panel]');
    this.stickyBundleList = this.stickyBar.querySelector('[data-sticky-bundle-list]');
    this.stickyBundleProgressHost = this.stickyBar.querySelector('[data-sticky-bundle-progress-host]');
    this.isStickyBundlePanelOpen = false;
    if (this.stickyBundlePanel) {
      this.stickyBundlePanel.hidden = false;
    }
    if (this.stickyBundleToggleButton) {
      this.stickyBundleToggleButton.setAttribute('aria-expanded', 'false');
    }

    if ('IntersectionObserver' in window) {
      this.stickyObservedElement = this.ctaButton || this.querySelector('[data-cta-button]') || this;
      this.stickyObserver = new IntersectionObserver(this.onStickyIntersection, {
        threshold: 0
      });
      this.stickyObserver.observe(this.stickyObservedElement);
    }

    this.syncStickyCtaDisabledState();
    this.updateStickySummarySubtext(this.stickySummarySubtext?.textContent || '');
    this.syncStickyTimerFromMain();
    this.renderStickyBundleItems();
    this.syncBundleProgressPlacement();
    if (this.stickyBar.classList.contains('is-bundle')) {
      this.toggleStickyBundlePanel(false);
    }
  }

  onStickyIntersection(entries) {
    const entry = entries?.[0];
    if (!entry) return;
    this.stickyScrollReady = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    this.updateStickyVisibility();
  }

  updateStickyVisibility() {
    let shouldShow = Boolean(this.stickyScrollReady);
    if (shouldShow && this.bundleForm && this.bundleCards?.length) {
      const totalQty = Array.isArray(this.bundleSelections)
        ? this.bundleSelections.reduce((sum, item) => sum + Math.max(0, item?.quantity || 0), 0)
        : 0;
      shouldShow = totalQty > 0;
    }
    this.setStickyVisible(shouldShow);
  }

  setStickyVisible(visible) {
    const next = Boolean(visible);
    if (!this.stickyBar || this.isStickyVisible === next) return;
    this.isStickyVisible = next;
    this.stickyBar.classList.toggle('is-visible', next);
    this.stickyBar.setAttribute('aria-hidden', next ? 'false' : 'true');
  }

  handleStickySubmit(button) {
    if (!button || button.disabled) return;

    if (this.bundleForm && this.bundleCards?.length) {
      if (this.bundleSubmitPending) return;
      const totalQty = this.getBundleSelectedQuantity();
      if (!this.isBundleMinimumReached(totalQty)) {
        this.updateCtaBundleState(totalQty);
        return;
      }
      this.submitBundleWithRechargeDynamic()
        .catch((error) => {
          console.error('[MainProduct] Recharge bundle submit error:', error);
        })
        .finally(() => {
          this.setBundleCtaLoading(false);
        });
      return;
    }

    const submitButton = this.ctaButton || this.productForm?.querySelector('[type="submit"]');
    if (!(submitButton instanceof HTMLElement)) return;
    const handledByThemeCart = this.dispatchThemeCartAdd(submitButton);
    if (!handledByThemeCart && this.productForm instanceof HTMLFormElement) {
      HTMLFormElement.prototype.submit.call(this.productForm);
    }
  }

  toggleStickyBundlePanel(forceOpen = null) {
    if (!this.stickyBar || !this.bundleForm || !this.stickyBundlePanel) return;

    const shouldOpen = typeof forceOpen === 'boolean'
      ? forceOpen
      : !this.isStickyBundlePanelOpen;
    this.isStickyBundlePanelOpen = shouldOpen;

    this.stickyBar.classList.toggle('is-bundle-panel-open', shouldOpen);
    this.stickyBundlePanel.classList.toggle('is-open', shouldOpen);

    if (this.stickyBundleToggleButton) {
      const closedLabel = this.stickyBundleToggleButton.dataset.labelClosed || 'Voir le contenu de mon pack';
      this.stickyBundleToggleButton.textContent = closedLabel;
      this.stickyBundleToggleButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      this.stickyBundleToggleButton.hidden = shouldOpen;
    }

    if (this.stickyBundleMobilePrice) {
      this.stickyBundleMobilePrice.hidden = shouldOpen;
    }

    if (this.stickyBundleCloseButton) {
      this.stickyBundleCloseButton.hidden = !shouldOpen;
    }

    if (this.stickyBundleProgressHost) {
      this.stickyBundleProgressHost.hidden = shouldOpen;
    }

    if (!shouldOpen && this.stickyBundleList) {
      this.stickyBundleList.scrollTop = 0;
    }

    const totalQty = Array.isArray(this.bundleSelections)
      ? this.bundleSelections.reduce((sum, item) => sum + Math.max(0, this.parseProgressInteger(item?.quantity, 0)), 0)
      : 0;
    const totalPrice = Array.isArray(this.bundleSelections)
      ? this.bundleSelections.reduce((sum, item) => {
          const itemPrice = this.parseProgressInteger(item?.priceCents, 0);
          const itemQty = this.parseProgressInteger(item?.quantity, 0);
          return sum + (Math.max(0, itemPrice) * Math.max(0, itemQty));
        }, 0)
      : 0;
    this.updateStickyBundleMobileUI(totalQty, totalPrice);
  }

  closeStickyBundlePanelWithAnimation() {
    if (!this.stickyBundleCloseButton) {
      this.toggleStickyBundlePanel(false);
      return;
    }

    if (this.stickyBundleCloseTimeout) {
      window.clearTimeout(this.stickyBundleCloseTimeout);
      this.stickyBundleCloseTimeout = null;
    }

    this.stickyBundleCloseButton.classList.add('is-rotating');
    this.stickyBundleCloseTimeout = window.setTimeout(() => {
      this.stickyBundleCloseButton?.classList.remove('is-rotating');
      this.toggleStickyBundlePanel(false);
      this.stickyBundleCloseTimeout = null;
    }, 180);
  }

  adjustStickyBundleItemQuantity(variantId, delta) {
    if (!this.bundleForm || !Array.isArray(this.bundleCards) || !variantId) return;
    const targetCard = this.bundleCards.find((card) => String(card.dataset.bundleVariantId) === String(variantId));
    if (!targetCard) return;
    const currentQty = this.parseProgressInteger(targetCard.dataset.bundleQty || '', 0);
    const nextQty = Math.max(0, currentQty + delta);
    this.setBundleCardQuantity(targetCard, nextQty);
  }

  dispatchThemeCartAdd(button) {
    if (!(button instanceof HTMLElement)) return false;
    if (!button.closest('form')) return false;
    if (!window.cart || typeof window.cart.cartAddEvent !== 'function') return false;

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          button
        }
      })
    );

    return true;
  }

  refreshAndOpenThemeCartDrawer() {
    const themeCart = window.cart;

    if (themeCart && typeof themeCart.getCart === 'function') {
      try {
        themeCart.getCart();
        return true;
      } catch (error) {
        console.warn('[MainProduct] Impossible de rafraichir le side-cart via window.cart.getCart()', error);
      }
    }

    if (themeCart && typeof themeCart.openCartDrawer === 'function') {
      try {
        themeCart.openCartDrawer();
        return true;
      } catch (error) {
        console.warn('[MainProduct] Impossible d\'ouvrir le side-cart via window.cart.openCartDrawer()', error);
      }
    }

    document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
    return false;
  }

  async fetchCartBundleItems() {
    const handle = (this.bundleForm?.dataset?.bundleParentProductHandle || '').trim();
    if (!handle) return [];
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) return [];
    const cart = await response.json();
    const items = (cart.items || [])
      .filter((item) => (item.properties || {})._rc_bundle_parent === handle)
      .map((item) => ({
        variantId: item.variant_id,
        quantity: item.quantity,
        key: item.key,
        sellingPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
        sellingPlanName: item.selling_plan_allocation?.selling_plan?.name || null
      }));
    this.lastCartBundleItems = items;
    return items;
  }

  applyCartItemsToBuilder(cartBundleItems) {
    if (!this.bundleCards?.length) return;

    this.bundleSyncFromCart = true;

    this.bundleCards.forEach((card) => {
      this.setBundleCardQuantity(card, 0, false);
    });

    const qtyByVariant = new Map();
    cartBundleItems.forEach((item) => {
      const current = qtyByVariant.get(item.variantId) || 0;
      qtyByVariant.set(item.variantId, current + item.quantity);
    });

    qtyByVariant.forEach((totalQty, variantId) => {
      const card = this.bundleCards.find((c) => String(c.dataset.bundleVariantId) === String(variantId));
      if (card) {
        this.setBundleCardQuantity(card, totalQty, false);
      }
    });

    this.updateBundleSelectionUI();

    this.bundleSyncFromCart = false;
  }

  async onCartChange(event) {
    if (this.bundleSubmitPending) return;
    if (!this.bundleForm || !this.bundleCards?.length) return;
    try {
      const items = await this.fetchCartBundleItems();
      this.applyCartItemsToBuilder(items);
    } catch (err) {
      console.warn('[MainProduct] onCartChange sync error:', err);
    }
  }

  async removeExistingBundleFromCart() {
    const items = this.lastCartBundleItems.length ? this.lastCartBundleItems : await this.fetchCartBundleItems();
    if (!items.length) return;
    const updates = {};
    items.forEach((item) => {
      updates[item.key] = 0;
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });
  }

  syncStickyCtaDisabledState() {
    if (!this.stickyCtaButton || !this.ctaButton) return;
    this.stickyCtaButton.disabled = this.ctaButton.disabled;
    this.stickyCtaButton.classList.toggle('is-loading', this.ctaButton.classList.contains('is-loading'));
    this.stickyCtaButton.setAttribute('aria-busy', this.ctaButton.getAttribute('aria-busy') || 'false');
  }

  setCtaOutOfStockState(isAvailable) {
    if (this.bundleForm) return;

    const isOutOfStock = !Boolean(isAvailable);
    [this.ctaButton, this.stickyCtaButton].forEach((btn) => {
      if (!btn) return;

      const label = btn.querySelector('[data-cta-label], [data-sticky-cta-label]');
      const separator = btn.querySelector('[data-cta-separator], [data-sticky-cta-separator]');
      const prices = btn.querySelector('[data-cta-prices], [data-sticky-cta-prices]');

      if (label) {
        if (!label.dataset.defaultLabel) {
          label.dataset.defaultLabel = label.textContent?.trim() || '';
        }
        label.textContent = isOutOfStock ? 'Rupture de stock' : (label.dataset.defaultLabel || '');
      }

      if (separator) separator.hidden = isOutOfStock;
      if (prices) prices.hidden = isOutOfStock;

      btn.classList.toggle('is-out-of-stock', isOutOfStock);
      btn.disabled = isOutOfStock;
    });
  }

  getBundleSelectedQuantity() {
    if (!Array.isArray(this.bundleSelections) || !this.bundleSelections.length) return 0;
    return this.bundleSelections.reduce(
      (sum, item) => sum + Math.max(0, this.parseProgressInteger(item?.quantity, 0)),
      0
    );
  }

  getBundleRemainingRequired(totalQty = 0) {
    const safeQty = Math.max(0, this.parseProgressInteger(totalQty, 0));
    const minProducts = Math.max(1, this.parseProgressInteger(this.bundleMinProducts, 4));
    return Math.max(0, minProducts - safeQty);
  }

  isBundleMinimumReached(totalQty = 0) {
    return this.getBundleRemainingRequired(totalQty) === 0;
  }

  getBundleMinimumMessage(totalQty = 0) {
    const remaining = this.getBundleRemainingRequired(totalQty);
    const productLabel = remaining > 1 ? 'produits' : 'produit';
    return `Choisissez encore ${remaining} ${productLabel}`;
  }

  updateCtaBundleState(totalQty = 0) {
    const hasMinimumProducts = this.isBundleMinimumReached(totalQty);
    const minimumMessage = this.getBundleMinimumMessage(totalQty);
    [this.ctaButton, this.stickyCtaButton].forEach((btn) => {
      if (!btn) return;
      const emptyLabel = btn.querySelector('[data-cta-empty], [data-sticky-cta-empty]');
      const label = btn.querySelector('[data-cta-label], [data-sticky-cta-label]');
      const separator = btn.querySelector('[data-cta-separator], [data-sticky-cta-separator]');
      const prices = btn.querySelector('[data-cta-prices], [data-sticky-cta-prices]');
      const isLoading = btn.classList.contains('is-loading');
      btn.classList.toggle('is-bundle-empty', !hasMinimumProducts);
      btn.disabled = isLoading || !hasMinimumProducts;
      if (emptyLabel) {
        emptyLabel.textContent = minimumMessage;
        emptyLabel.hidden = hasMinimumProducts;
      }
      if (label) label.hidden = !hasMinimumProducts;
      if (separator) separator.hidden = !hasMinimumProducts;
      if (prices) prices.hidden = !hasMinimumProducts;
    });
  }

  updateStickySummarySubtext(text) {
    if (!this.stickySummarySubtext) return;
    const value = String(text || '').trim();
    this.stickySummarySubtext.textContent = value;
    this.stickySummarySubtext.hidden = value.length === 0;
  }

  syncStickyTimerFromMain() {
    if (!this.stickyTimerEl || !this.timerEl) return;

    this.stickyTimerEl.hidden = this.timerEl.hidden;
    this.stickyTimerEl.classList.toggle('is-hidden', this.timerEl.classList.contains('is-hidden'));

    if (this.stickyTimerCountdown && this.timerCountdown) {
      this.stickyTimerCountdown.classList.toggle('is-hidden', this.timerCountdown.classList.contains('is-hidden'));
    }

    if (this.stickyTimerMessage && this.timerMessage) {
      this.stickyTimerMessage.classList.toggle('is-hidden', this.timerMessage.classList.contains('is-hidden'));
      this.stickyTimerMessage.innerHTML = this.timerMessage.innerHTML;
    }

    if (this.stickyTimerValue && this.timerValue) {
      this.stickyTimerValue.textContent = this.timerValue.textContent;
    }
  }

  renderStickyBundleItems() {
    if (!this.stickyBundleItems) return;
    if (!this.bundleForm || !this.bundleCards?.length) {
      if (this.stickyBundleItemsWrap) {
        this.stickyBundleItemsWrap.hidden = true;
      }
      this.stickyBundleItems.innerHTML = '';
      if (this.stickyBundleList) {
        this.stickyBundleList.innerHTML = '';
      }
      return;
    }

    const selections = Array.isArray(this.bundleSelections) ? this.bundleSelections.filter((item) => item && item.quantity > 0) : [];
    this.stickyBundleItems.innerHTML = '';

    if (this.stickyBundleItemsWrap) {
      this.stickyBundleItemsWrap.hidden = false;
    }

    const fragment = document.createDocumentFragment();

    selections.forEach((item, index) => {
      if (index > 0) {
        const separator = document.createElement('span');
        separator.className = 'main-product-sticky__bundle-separator';
        separator.setAttribute('aria-hidden', 'true');
        separator.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none"><path d="M2.36426 5.46387C2.37012 5.08887 2.37598 4.86328 2.37891 4.4502C2.38184 4.14844 2.20605 3.97559 1.91895 3.97852C1.51758 3.98145 1.28027 3.9873 0.905273 3.99316C-0.301758 4.0166 -0.301758 2.33789 0.905273 2.36133C0.928711 2.36133 1.57031 2.37598 1.94238 2.37891C2.21484 2.38184 2.38477 2.20312 2.38184 1.89844C2.37891 1.55859 2.38184 1.22168 2.37598 0.905273C2.35254 -0.301758 4.01953 -0.301758 3.99609 0.905273C3.99023 1.23047 3.99023 1.55859 3.98145 1.88672C3.97266 2.18262 4.1543 2.38184 4.48828 2.37891C4.82812 2.37598 5.11816 2.37891 5.46387 2.37305C6.6709 2.34961 6.6709 4.0166 5.46387 3.99316C5.12695 3.9873 4.81055 3.9873 4.48242 3.98145C4.1748 3.97559 3.97559 4.14258 3.97852 4.42383C3.9873 5.41113 3.99023 5.10059 3.99609 5.46387C4.01953 6.6709 2.34082 6.6709 2.36426 5.46387Z" fill="white"/></svg>';
        fragment.appendChild(separator);
      }

      const itemEl = document.createElement('div');
      itemEl.className = 'main-product-sticky__bundle-item';

      const qtyEl = document.createElement('span');
      qtyEl.className = 'main-product-sticky__bundle-item-qty';
      qtyEl.textContent = `x${Math.max(1, this.parseProgressInteger(item.quantity, 1))}`;
      itemEl.appendChild(qtyEl);

      const mediaEl = document.createElement('div');
      mediaEl.className = 'main-product-sticky__bundle-item-media';

      if (item.imageSrc) {
        const imageEl = document.createElement('img');
        imageEl.src = item.imageSrc;
        imageEl.width = 53;
        imageEl.height = 53;
        imageEl.loading = 'lazy';
        imageEl.alt = item.imageAlt || item.title || '';
        mediaEl.appendChild(imageEl);
      }

      itemEl.appendChild(mediaEl);

      const titleText = String(item.title || '').trim();
      if (titleText) {
        const titleEl = document.createElement('span');
        titleEl.className = 'main-product-sticky__bundle-item-title';
        titleEl.textContent = titleText;
        itemEl.appendChild(titleEl);
      }

      fragment.appendChild(itemEl);
    });

    if (selections.length > 0) {
      const separator = document.createElement('span');
      separator.className = 'main-product-sticky__bundle-separator';
      separator.setAttribute('aria-hidden', 'true');
      separator.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none"><path d="M2.36426 5.46387C2.37012 5.08887 2.37598 4.86328 2.37891 4.4502C2.38184 4.14844 2.20605 3.97559 1.91895 3.97852C1.51758 3.98145 1.28027 3.9873 0.905273 3.99316C-0.301758 4.0166 -0.301758 2.33789 0.905273 2.36133C0.928711 2.36133 1.57031 2.37598 1.94238 2.37891C2.21484 2.38184 2.38477 2.20312 2.38184 1.89844C2.37891 1.55859 2.38184 1.22168 2.37598 0.905273C2.35254 -0.301758 4.01953 -0.301758 3.99609 0.905273C3.99023 1.23047 3.99023 1.55859 3.98145 1.88672C3.97266 2.18262 4.1543 2.38184 4.48828 2.37891C4.82812 2.37598 5.11816 2.37891 5.46387 2.37305C6.6709 2.34961 6.6709 4.0166 5.46387 3.99316C5.12695 3.9873 4.81055 3.9873 4.48242 3.98145C4.1748 3.97559 3.97559 4.14258 3.97852 4.42383C3.9873 5.41113 3.99023 5.10059 3.99609 5.46387C4.01953 6.6709 2.34082 6.6709 2.36426 5.46387Z" fill="white"/></svg>';
      fragment.appendChild(separator);
    }

    const placeholderItem = document.createElement('div');
    placeholderItem.className = 'main-product-sticky__bundle-item main-product-sticky__bundle-item--placeholder';
    placeholderItem.setAttribute('aria-hidden', 'true');
    const placeholderMedia = document.createElement('div');
    placeholderMedia.className = 'main-product-sticky__bundle-item-media main-product-sticky__bundle-item-media--placeholder';
    placeholderItem.appendChild(placeholderMedia);
    fragment.appendChild(placeholderItem);

    this.stickyBundleItems.appendChild(fragment);
    this.renderStickyBundleMobileList(selections);
  }

  renderStickyBundleMobileList(selections = []) {
    if (!this.stickyBundleList) return;

    this.stickyBundleList.innerHTML = '';
    if (!selections.length) return;

    const fragment = document.createDocumentFragment();

    selections.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'main-product-sticky__bundle-mobile-item';

      const media = document.createElement('div');
      media.className = 'main-product-sticky__bundle-mobile-item-media';
      if (item.imageSrc) {
        const image = document.createElement('img');
        image.src = item.imageSrc;
        image.width = 60;
        image.height = 60;
        image.loading = 'lazy';
        image.alt = item.imageAlt || item.title || '';
        media.appendChild(image);
      }
      row.appendChild(media);

      const content = document.createElement('div');
      content.className = 'main-product-sticky__bundle-mobile-item-content';
      const title = document.createElement('p');
      title.className = 'main-product-sticky__bundle-mobile-item-title';
      title.textContent = item.title || '';
      content.appendChild(title);

      const meta = document.createElement('p');
      meta.className = 'main-product-sticky__bundle-mobile-item-meta';
      const weight = String(item.weight || '').trim();
      const unitPrice = this.formatMoney(this.parseProgressInteger(item.priceCents, 0));
      meta.textContent = weight ? `${weight} | ${unitPrice}` : unitPrice;
      content.appendChild(meta);
      row.appendChild(content);

      const stepper = document.createElement('div');
      stepper.className = 'main-product-sticky__bundle-mobile-item-stepper';

      const minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'main-product-sticky__bundle-mobile-step-btn main-product-sticky__bundle-mobile-step-btn--minus';
      minus.dataset.stickyBundleMinus = '';
      minus.dataset.stickyBundleVariantId = String(item.variantId || '');
      minus.setAttribute('aria-label', 'Retirer un produit');
      minus.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="2" viewBox="0 0 6 2" fill="none"><path d="M1.25491 1.61133C-0.421671 1.61133 -0.417621 0 1.263 0H4.75385C6.42637 0 6.43447 1.61133 4.7417 1.61133H1.25491Z" fill="#181831"/></svg>';
      stepper.appendChild(minus);

      const qty = document.createElement('span');
      qty.className = 'main-product-sticky__bundle-mobile-item-qty';
      qty.textContent = String(Math.max(1, this.parseProgressInteger(item.quantity, 1)));
      stepper.appendChild(qty);

      const plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'main-product-sticky__bundle-mobile-step-btn main-product-sticky__bundle-mobile-step-btn--plus';
      plus.dataset.stickyBundlePlus = '';
      plus.dataset.stickyBundleVariantId = String(item.variantId || '');
      plus.setAttribute('aria-label', 'Ajouter un produit');
      plus.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none"><path d="M2.36426 5.46387C2.37012 5.08887 2.37598 4.86328 2.37891 4.4502C2.38184 4.14844 2.20605 3.97559 1.91895 3.97852C1.51758 3.98145 1.28027 3.9873 0.905273 3.99316C-0.301758 4.0166 -0.301758 2.33789 0.905273 2.36133C0.928711 2.36133 1.57031 2.37598 1.94238 2.37891C2.21484 2.38184 2.38477 2.20312 2.38184 1.89844C2.37891 1.55859 2.38184 1.22168 2.37598 0.905273C2.35254 -0.301758 4.01953 -0.301758 3.99609 0.905273C3.99023 1.23047 3.99023 1.55859 3.98145 1.88672C3.97266 2.18262 4.1543 2.38184 4.48828 2.37891C4.82812 2.37598 5.11816 2.37891 5.46387 2.37305C6.6709 2.34961 6.6709 4.0166 5.46387 3.99316C5.12695 3.9873 4.81055 3.9873 4.48242 3.98145C4.1748 3.97559 3.97559 4.14258 3.97852 4.42383C3.9873 5.41113 3.99023 5.10059 3.99609 5.46387C4.01953 6.6709 2.34082 6.6709 2.36426 5.46387Z" fill="white"/></svg>';
      stepper.appendChild(plus);

      row.appendChild(stepper);
      fragment.appendChild(row);
    });

    this.stickyBundleList.appendChild(fragment);
  }

  updateStickyBundleMobileUI(totalQty = 0, totalPriceCents = 0) {
    if (!this.stickyBar || !this.stickyBundleMobile) return;

    if (!this.stickyBundleTotal && this.stickyBar) {
      this.stickyBundleTotal = this.stickyBar.querySelector('[data-sticky-bundle-total]');
    }

    if (this.stickyBundleTotal) {
      this.stickyBundleTotal.textContent = String(Math.max(0, this.parseProgressInteger(totalQty, 0)));
    }

    if (this.stickyBundleMobilePrice) {
      const ctaPriceText = this.ctaButton?.querySelector('[data-price]')?.textContent?.trim() || '';
      this.stickyBundleMobilePrice.textContent = ctaPriceText || this.formatMoneyTight(Math.max(0, totalPriceCents));
    }

    const hasItems = totalQty > 0;

    if (!hasItems && this.isStickyBundlePanelOpen) {
      this.toggleStickyBundlePanel(false);
    }

    if (this.stickyBundleToggleButton) {
      this.stickyBundleToggleButton.disabled = !hasItems;
      this.stickyBundleToggleButton.classList.toggle('is-disabled', !hasItems);
    }

    if (this.stickyBundleMobileTitle) {
      this.stickyBundleMobileTitle.textContent = this.isStickyBundlePanelOpen ? 'Contenu de votre pack' : 'Votre sélection';
    }
  }

  openDrawer() {
    this.openDrawerInstance(this.drawer, this.drawerPanel);
  }

  closeDrawer() {
    this.closeDrawerInstance(this.drawer, this.drawerPanel);
  }

  openPackDrawer(productHandle = '') {
    this.openDrawerInstance(this.packDrawer, this.packDrawerPanel);
    this.loadPackDrawerContent(productHandle);
  }

  closePackDrawer() {
    this.closeDrawerInstance(this.packDrawer, this.packDrawerPanel);
  }

  openDrawerInstance(drawer, panel) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('main-product-drawer-open');
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
    }
  }

  closeDrawerInstance(drawer, panel) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
    }
    const isPrimaryOpen = this.drawer && this.drawer.classList.contains('is-open');
    const isPackOpen = this.packDrawer && this.packDrawer.classList.contains('is-open');
    if (!isPrimaryOpen && !isPackOpen) {
      document.body.classList.remove('main-product-drawer-open');
    }
  }

  loadPackDrawerContent(productHandle) {
    if (!this.packDrawerContent) return;
    this.activePackHandle = productHandle || '';

    if (!productHandle) {
      this.packDrawerContent.innerHTML = '';
      return;
    }

    if (this.packModalCache[productHandle]) {
      this.renderPackDrawerContent(this.packModalCache[productHandle]);
      return;
    }

    this.packDrawerContent.innerHTML = `
      <div class="main-product-pack-modal__loading" role="status" aria-live="polite" aria-label="Chargement">
        <span class="main-product-pack-modal__loading-spinner" aria-hidden="true"></span>
      </div>
    `;

    fetch(`/products/${encodeURIComponent(productHandle)}?view=${encodeURIComponent(this.packModalView)}`)
      .then((response) => {
        if (!response.ok) throw new Error('pack modal fetch failed');
        return response.text();
      })
      .then((html) => {
        this.packModalCache[productHandle] = html;
        if (this.activePackHandle !== productHandle) return;
        this.renderPackDrawerContent(html);
      })
      .catch(() => {
        if (this.activePackHandle !== productHandle) return;
        this.packDrawerContent.innerHTML = '<p class="main-product-pack-modal__error">Impossible de charger les informations.</p>';
      });
  }

  renderPackDrawerContent(html) {
    if (!this.packDrawerContent) return;
    this.packDrawerContent.innerHTML = html;
    this.initPackModalAccordions();
  }

  initPackModalAccordions() {
    if (!this.packDrawerContent) return;
    const accordions = this.packDrawerContent.querySelectorAll('.main-product-pack-modal__accordion');
    accordions.forEach((accordion) => {
      const content = accordion.querySelector('.main-product-pack-modal__accordion-content');
      if (!content) return;
      if (accordion.hasAttribute('open')) {
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
      }
    });
  }

  handlePackModalAccordionClick(event, summary) {
    event.preventDefault();
    const accordion = summary.closest('.main-product-pack-modal__accordion');
    if (!accordion || !this.packDrawerContent) return;

    const content = accordion.querySelector('.main-product-pack-modal__accordion-content');
    if (!content) return;

    if (accordion.open) {
      this.animatePackModalAccordionClose(accordion, content);
      return;
    }

    const openedAccordions = this.packDrawerContent.querySelectorAll('.main-product-pack-modal__accordion[open]');
    openedAccordions.forEach((item) => {
      if (item === accordion) return;
      const itemContent = item.querySelector('.main-product-pack-modal__accordion-content');
      if (!itemContent) return;
      this.animatePackModalAccordionClose(item, itemContent);
    });

    accordion.open = true;
    const targetHeight = content.scrollHeight;
    content.style.height = '0px';
    requestAnimationFrame(() => {
      content.style.height = `${targetHeight}px`;
    });
    content.addEventListener(
      'transitionend',
      () => {
        if (accordion.open) {
          content.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  animatePackModalAccordionClose(accordion, content) {
    content.style.height = `${content.scrollHeight}px`;
    requestAnimationFrame(() => {
      content.style.height = '0px';
    });
    content.addEventListener(
      'transitionend',
      () => {
        accordion.open = false;
      },
      { once: true }
    );
  }

  handleVideoToggle(card) {
    this.openVideoModal(card);
  }

  initVideoModal() {
    if (this.videoModal) return;

    const modal = document.createElement('div');
    modal.className = 'main-product-video-modal';
    modal.setAttribute('data-video-modal-overlay', '');
    modal.setAttribute('aria-hidden', 'true');

    const dialog = document.createElement('div');
    dialog.className = 'main-product-video-modal__dialog';
    dialog.setAttribute('data-video-modal-dialog', '');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    const player = document.createElement('div');
    player.className = 'main-product-video-modal__player';
    player.setAttribute('data-video-modal-player', '');

    dialog.appendChild(player);
    modal.appendChild(dialog);
    this.appendChild(modal);

    this.videoModal = modal;
    this.videoModalDialog = dialog;
    this.videoModalPlayer = player;
  }

  destroyVideoModal() {
    if (this.videoModalActiveVideo) {
      this.videoModalActiveVideo.pause();
      this.videoModalActiveVideo = null;
    }

    if (this.videoModalPlayer) {
      this.videoModalPlayer.innerHTML = '';
    }

    if (this.videoModal) {
      this.videoModal.remove();
    }

    this.videoModal = null;
    this.videoModalDialog = null;
    this.videoModalPlayer = null;
    document.body.classList.remove('main-product-video-modal-open');
  }

  openVideoModal(card) {
    if (!card) return;
    const sourceVideo = card.querySelector('video');
    if (!sourceVideo) return;

    this.initVideoModal();
    if (!this.videoModal || !this.videoModalPlayer) return;

    const cards = Array.from(this.querySelectorAll('.main-product__video-card'));
    cards.forEach((item) => {
      const otherVideo = item.querySelector('video');
      if (otherVideo) {
        otherVideo.pause();
      }
      item.classList.remove('is-playing');
    });

    if (this.videoModalActiveVideo) {
      this.videoModalActiveVideo.pause();
      this.videoModalActiveVideo = null;
    }

    this.videoModalPlayer.innerHTML = '';

    const modalVideo = sourceVideo.cloneNode(true);
    modalVideo.controls = true;
    modalVideo.muted = false;
    modalVideo.removeAttribute('muted');
    modalVideo.playsInline = true;
    modalVideo.loop = true;
    modalVideo.autoplay = true;

    this.videoModalPlayer.appendChild(modalVideo);
    this.videoModalActiveVideo = modalVideo;

    this.videoModal.classList.add('is-open');
    this.videoModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('main-product-video-modal-open');

    modalVideo.play().catch(() => {});
  }

  closeVideoModal() {
    if (!this.videoModal) return;

    this.videoModal.classList.remove('is-open');
    this.videoModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('main-product-video-modal-open');

    if (this.videoModalActiveVideo) {
      this.videoModalActiveVideo.pause();
      this.videoModalActiveVideo = null;
    }

    if (this.videoModalPlayer) {
      this.videoModalPlayer.innerHTML = '';
    }
  }

  handleQuantitySelection(button) {
    if (button.disabled) return;

    const selector = button.closest('[data-quantity-selector]');
    if (!selector) return;

    selector.querySelectorAll('.main-product-form-block__quantity-button').forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (!this.quantityInput) return;

    const quantity = Number.parseInt(button.dataset.quantity, 10);
    if (Number.isNaN(quantity) || quantity < 1) return;
    this.quantityInput.value = String(quantity);
    this.updateFrequencyPrices();
    this.updateBundleProgress({ quantity });
  }

  handleFrequencySelection(button) {
    if (button.disabled) return;

    const selector = button.closest('[data-frequency-selector]');
    if (!selector) return;

    selector.querySelectorAll('.main-product-form-block__frequency-button').forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (!this.sellingPlanInput) return;

    const frequency = button.dataset.frequency;
    const storedPlanId = this.selectedSubscriptionPlanId || '';
    const selectedPlanButton = selector.querySelector('.main-product-form-block__subscription-plan-button.is-active')
      || selector.querySelector('.main-product-form-block__subscription-plan-button');
    const sellingPlanId = storedPlanId || selectedPlanButton?.dataset?.sellingPlanChoiceId || button.dataset.sellingPlanId;

    if (frequency === 'subscription' && sellingPlanId) {
      this.selectedSubscriptionPlanId = String(sellingPlanId);
      if (this.subscriptionButton) {
        this.subscriptionButton.dataset.sellingPlanId = sellingPlanId;
      }
      this.sellingPlanInput.value = sellingPlanId;
      this.updateFrequencyPrices();
      return;
    }

    this.sellingPlanInput.value = '';
    this.updateFrequencyPrices();
  }

  handleSubscriptionPlanSelection(button) {
    if (button.disabled) return;

    const list = button.closest('.main-product-form-block__subscription-plan-list');
    if (!list) return;

    const planButtons = Array.from(list.querySelectorAll('.main-product-form-block__subscription-plan-button'));
    if (!planButtons.length) return;

    const activeIndex = planButtons.indexOf(button);

    planButtons.forEach((item, index) => {
      const isActive = index === activeIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    list.style.setProperty('--plan-count', String(planButtons.length));
    list.style.setProperty('--active-plan-index', String(Math.max(0, activeIndex)));
    this.updateSubscriptionBadge(list.closest('[data-frequency-selector]'));

    const selectedPlanId = button.dataset.sellingPlanChoiceId || '';
    this.selectedSubscriptionPlanId = selectedPlanId;
    if (this.subscriptionButton && selectedPlanId) {
      this.subscriptionButton.dataset.sellingPlanId = selectedPlanId;
      this.handleFrequencySelection(this.subscriptionButton);
      return;
    }

    if (this.sellingPlanInput && selectedPlanId) {
      this.sellingPlanInput.value = selectedPlanId;
      this.updateFrequencyPrices();
    }
  }

  initSubscriptionPlans() {
    const list = this.querySelector('.main-product-form-block__subscription-plan-list');
    if (!list) return;

    const planButtons = Array.from(list.querySelectorAll('.main-product-form-block__subscription-plan-button'));
    if (!planButtons.length) return;

    let activeButton = planButtons.find((button) => button.classList.contains('is-active')) || planButtons[0];
    const activeIndex = planButtons.indexOf(activeButton);

    planButtons.forEach((button, index) => {
      const isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    list.style.setProperty('--plan-count', String(planButtons.length));
    list.style.setProperty('--active-plan-index', String(Math.max(0, activeIndex)));
    this.updateSubscriptionBadge(list.closest('[data-frequency-selector]'));

    activeButton = planButtons[Math.max(0, activeIndex)] || planButtons[0];
    const selectedPlanId = activeButton?.dataset?.sellingPlanChoiceId || '';
    this.selectedSubscriptionPlanId = selectedPlanId;
    if (this.subscriptionButton && selectedPlanId) {
      this.subscriptionButton.dataset.sellingPlanId = selectedPlanId;
    }

    const subscriptionIsActive = this.subscriptionButton?.classList.contains('is-active');
    this.toggleSubscriptionPlans(Boolean(subscriptionIsActive));
  }

  toggleSubscriptionPlans(forceOpen = null) {
    if (!this.subscriptionButton) return;
    const isCurrentlyOpen = this.subscriptionButton.classList.contains('is-plans-open');
    const shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : !isCurrentlyOpen;
    this.subscriptionButton.classList.toggle('is-plans-open', shouldOpen);
  }

  syncSellingPlanBeforeSubmit() {
    if (!this.productForm || !this.sellingPlanInput) return;
    const isSubscription = this.subscriptionButton?.classList.contains('is-active');

    let targetPlanId = '';
    if (isSubscription) {
      targetPlanId = this.selectedSubscriptionPlanId
        || this.subscriptionButton?.dataset?.sellingPlanId
        || this.sellingPlanInput.value
        || '';
    }

    this.sellingPlanInput.value = targetPlanId;

    const planInputs = Array.from(this.productForm.querySelectorAll('[name=\"selling_plan\"]'));
    planInputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement)) return;
      input.value = targetPlanId;
    });
  }

  updateSubscriptionBadge(frequencySelector) {
    const badge = frequencySelector?.querySelector('[data-subscription-badge]');
    if (!badge) return;

    const defaultLabel = badge.dataset.defaultLabel || badge.textContent?.trim() || '';
    const selectedPlanButton = frequencySelector?.querySelector('.main-product-form-block__subscription-plan-button.is-active')
      || frequencySelector?.querySelector('.main-product-form-block__subscription-plan-button');
    const discount = this.parseDiscountPercent(selectedPlanButton?.dataset?.sellingPlanDiscount || '');

    if (discount > 0) {
      const discountText = Number.isInteger(discount)
        ? String(discount)
        : String(discount).replace('.', ',');
      badge.textContent = `+${discountText}% de réduction`;
      return;
    }

    badge.textContent = defaultLabel;
  }

  updateFrequencyPrices() {
    if (this.bundleForm && this.bundleCards?.length) {
      this.updateBundleFrequencyPrices();
      return;
    }

    if (!this.oneTimeButton && !this.subscriptionButton) return;
    const frequencySelector = this.frequencySelector || this.oneTimeButton?.closest('[data-frequency-selector]') || this.subscriptionButton?.closest('[data-frequency-selector]');
    if (!frequencySelector) return;

    const basePrice = Number.parseInt(frequencySelector.dataset.basePrice, 10);
    if (Number.isNaN(basePrice)) return;

    const quantityButton = this.querySelector('.main-product-form-block__quantity-button.is-active') || this.querySelector('.main-product-form-block__quantity-button');
    const quantityValue = quantityButton ? Number.parseInt(quantityButton.dataset.quantity, 10) : 1;
    const quantity = Number.isNaN(quantityValue) || quantityValue < 1 ? 1 : quantityValue;

    const discountText = quantityButton?.dataset?.discount || '';
    const discountPercent = this.parseDiscountPercent(discountText);
    const totalPrice = basePrice * quantity;
    const discountedPrice = discountPercent > 0 ? Math.round(totalPrice * (1 - discountPercent / 100)) : totalPrice;

    if (this.oneTimeButton) {
      this.updateButtonPrices(this.oneTimeButton, totalPrice, discountedPrice, discountPercent > 0);
    }

    const subscriptionDiscount = this.getSelectedSubscriptionDiscount(frequencySelector);
    const subscriptionPrice = subscriptionDiscount > 0 ? Math.round(discountedPrice * (1 - subscriptionDiscount / 100)) : discountedPrice;

    if (this.subscriptionButton) {
      this.updateButtonPrices(this.subscriptionButton, discountedPrice, subscriptionPrice, subscriptionDiscount > 0);
    }

    const activeFrequencyButton = this.querySelector('.main-product-form-block__frequency-button.is-active') || this.oneTimeButton || this.subscriptionButton;
    const isSubscription = activeFrequencyButton?.dataset?.frequency === 'subscription';
    const ctaPrice = isSubscription ? subscriptionPrice : discountedPrice;
    const ctaCompare = totalPrice;
    const ctaHasDiscount = isSubscription ? subscriptionDiscount > 0 || discountPercent > 0 : discountPercent > 0;

    if (this.ctaButton) {
      this.updateMainAndStickyCtaPrices(ctaCompare, ctaPrice, ctaHasDiscount);
    }
  }

  updateBundleFrequencyPrices() {
    if (!this.oneTimeButton && !this.subscriptionButton && !this.ctaButton && !this.bundleHeadingPrice) return;

    const frequencySelector = this.frequencySelector
      || this.oneTimeButton?.closest('[data-frequency-selector]')
      || this.subscriptionButton?.closest('[data-frequency-selector]');

    const selections = Array.isArray(this.bundleSelections) ? this.bundleSelections : [];

    let totalPrice = 0;
    let totalQty = 0;
    selections.forEach((item) => {
      const itemPrice = Math.max(0, this.parseProgressInteger(item?.priceCents, 0));
      const itemQty = Math.max(0, this.parseProgressInteger(item?.quantity, 0));
      totalPrice += itemPrice * itemQty;
      totalQty += itemQty;
    });

    const progressDiscountPercent = this.getBundleProgressDiscountPercent({
      priceCents: totalPrice,
      quantity: totalQty
    });

    // One-time promo price (progress discount per-unit)
    let promoPrice = 0;
    selections.forEach((item) => {
      const itemPrice = Math.max(0, this.parseProgressInteger(item?.priceCents, 0));
      const itemQty = Math.max(0, this.parseProgressInteger(item?.quantity, 0));
      const unitPromo = progressDiscountPercent > 0
        ? Math.max(0, itemPrice - Math.floor(itemPrice * progressDiscountPercent / 100))
        : itemPrice;
      promoPrice += unitPromo * itemQty;
    });

    // Subscription price: use real selling plan allocation prices from Shopify
    const subscriptionDiscount = this.getSelectedSubscriptionDiscount(frequencySelector);
    const activePlanMeta = this.getActiveSubscriptionPlanMeta();
    let subscriptionPrice = 0;
    let subscriptionCompare = 0;
    let hasRealSellingPlanPrices = false;

    if (subscriptionDiscount > 0) {
      selections.forEach((item) => {
        const itemQty = Math.max(0, this.parseProgressInteger(item?.quantity, 0));
        const plan = activePlanMeta ? this.resolveBundleChildSellingPlan(item, activePlanMeta) : null;
        if (plan && plan.price > 0) {
          hasRealSellingPlanPrices = true;
          // Selling plan price = base abo, puis on applique la remise progressive par dessus
          const unitSubBase = plan.price;
          const unitSub = progressDiscountPercent > 0
            ? Math.max(0, unitSubBase - Math.floor(unitSubBase * progressDiscountPercent / 100))
            : unitSubBase;
          subscriptionPrice += unitSub * itemQty;
          subscriptionCompare += unitSubBase * itemQty;
        } else {
          // Fallback: calcul manuel per-unit
          const itemPrice = Math.max(0, this.parseProgressInteger(item?.priceCents, 0));
          const unitSub = Math.max(0, itemPrice - Math.floor(itemPrice * subscriptionDiscount / 100));
          const unitSubPromo = progressDiscountPercent > 0
            ? Math.max(0, unitSub - Math.floor(unitSub * progressDiscountPercent / 100))
            : unitSub;
          subscriptionPrice += unitSubPromo * itemQty;
          subscriptionCompare += unitSub * itemQty;
        }
      });
    } else {
      subscriptionPrice = promoPrice;
      subscriptionCompare = promoPrice;
    }

    if (this.oneTimeButton) {
      this.updateButtonPrices(this.oneTimeButton, totalPrice, promoPrice, progressDiscountPercent > 0 && promoPrice < totalPrice);
    }

    if (this.subscriptionButton) {
      const subCompare = hasRealSellingPlanPrices ? subscriptionCompare : promoPrice;
      this.updateButtonPrices(
        this.subscriptionButton,
        subCompare,
        subscriptionPrice,
        subscriptionDiscount > 0 && subscriptionPrice < subCompare
      );
    }

    if (this.ctaButton) {
      const activeFrequencyButton = this.querySelector('.main-product-form-block__frequency-button.is-active')
        || this.oneTimeButton
        || this.subscriptionButton;
      const isSubscription = activeFrequencyButton?.dataset?.frequency === 'subscription';
      const subCompare = hasRealSellingPlanPrices ? subscriptionCompare : promoPrice;
      const ctaPrice = isSubscription ? subscriptionPrice : promoPrice;
      const ctaCompare = isSubscription ? subCompare : totalPrice;
      const ctaHasDiscount = isSubscription
        ? (subscriptionDiscount > 0 && subscriptionPrice < subCompare)
        : (progressDiscountPercent > 0 && promoPrice < totalPrice);

      this.updateMainAndStickyCtaPrices(ctaCompare, ctaPrice, ctaHasDiscount);
      this.updateBundleHeadingPrices(ctaCompare, ctaPrice, ctaHasDiscount);
      this.updateStickyBundleMobileUI(totalQty, totalPrice);
      return;
    }

    this.updateBundleHeadingPrices(totalPrice, promoPrice, progressDiscountPercent > 0 && promoPrice < totalPrice);
    this.updateStickyBundleMobileUI(totalQty, totalPrice);
  }

  updateButtonPrices(button, comparePrice, price, showCompare) {
    if (!button) return;
    const compareEl = button.querySelector('[data-price-compare]');
    const priceEl = button.querySelector('[data-price]');

    if (priceEl) {
      priceEl.textContent = this.formatMoney(price);
    }

    if (compareEl) {
      const shouldShow = showCompare && price < comparePrice;
      compareEl.hidden = !shouldShow;
      compareEl.textContent = shouldShow ? this.formatMoney(comparePrice) : '';
    }
  }

  updateMainAndStickyCtaPrices(comparePrice, price, showCompare) {
    if (this.ctaButton) {
      this.updateButtonPrices(this.ctaButton, comparePrice, price, showCompare);
    }
    if (this.stickyCtaButton) {
      this.updateButtonPrices(this.stickyCtaButton, comparePrice, price, showCompare);
      this.syncStickyCtaDisabledState();
    }
  }

  updateBundleHeadingPrices(comparePrice, price, showCompare) {
    if (!this.bundleHeadingPrice) return;

    this.bundleHeadingPrice.textContent = this.formatMoneyTight(Math.max(0, this.parseProgressInteger(price, 0)));

    if (!this.bundleHeadingPriceCompare) return;
    const normalizedCompare = Math.max(0, this.parseProgressInteger(comparePrice, 0));
    const normalizedPrice = Math.max(0, this.parseProgressInteger(price, 0));
    const shouldShow = Boolean(showCompare) && normalizedCompare > normalizedPrice;
    this.bundleHeadingPriceCompare.hidden = !shouldShow;
    this.bundleHeadingPriceCompare.textContent = shouldShow ? this.formatMoneyTight(normalizedCompare) : '';
  }

  parseDiscountPercent(value) {
    if (!value) return 0;
    const normalized = String(value).replace(',', '.').replace(/[^0-9.]/g, '');
    const percent = Number.parseFloat(normalized);
    return Number.isNaN(percent) ? 0 : percent;
  }

  getSelectedSubscriptionDiscount(frequencySelector) {
    const fallbackDiscount = this.parseDiscountPercent(frequencySelector?.dataset?.subscriptionDiscount || '0');
    const selectedPlanButton = frequencySelector?.querySelector('.main-product-form-block__subscription-plan-button.is-active')
      || frequencySelector?.querySelector('.main-product-form-block__subscription-plan-button');
    const selectedDiscountRaw = selectedPlanButton?.dataset?.sellingPlanDiscount;

    if (selectedDiscountRaw === undefined || selectedDiscountRaw === null) {
      return fallbackDiscount;
    }

    if (String(selectedDiscountRaw).trim() === '') {
      return fallbackDiscount;
    }

    return Math.max(0, this.parseDiscountPercent(selectedDiscountRaw));
  }

  getBundleProgressDiscountPercent(state = {}) {
    const firstProgress = this.bundleProgressItems?.[0];
    if (!firstProgress || !Array.isArray(firstProgress.steps) || !firstProgress.steps.length) return 0;

    const currentPriceCents = Number.isFinite(state.priceCents) ? Math.max(0, Math.round(state.priceCents)) : 0;
    const currentQuantity = Number.isFinite(state.quantity) ? Math.max(0, Math.round(state.quantity)) : 0;
    const currentValue = firstProgress.mode === 'quantity' ? currentQuantity : currentPriceCents;

    let matchedDiscount = 0;
    firstProgress.steps.forEach((step) => {
      const target = firstProgress.mode === 'quantity' ? step.targetQty : step.targetPriceCents;
      if (!Number.isFinite(target) || target <= 0) return;
      if (currentValue < target) return;
      matchedDiscount = this.parseDiscountPercent(step.label || '');
    });

    return Math.max(0, matchedDiscount);
  }

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const format = window.Shopify.money_format || '{{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }

    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'fr-FR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  formatMoneyTight(cents) {
    return this.formatMoney(cents).replace(/\s+€/g, '€');
  }

  syncFormProductInputs() {
    if (this.packForm) {
      this.initPackForm();
      return;
    }

    this.initSubscriptionPlans();

    if (this.quantityInput) {
      const quantityButton = this.querySelector('.main-product-form-block__quantity-button.is-active') || this.querySelector('.main-product-form-block__quantity-button');
      if (quantityButton) {
        this.handleQuantitySelection(quantityButton);
      } else {
        this.quantityInput.value = '1';
      }
    }

    if (this.sellingPlanInput) {
      const frequencyButton = this.querySelector('.main-product-form-block__frequency-button.is-active') || this.querySelector('.main-product-form-block__frequency-button');
      if (frequencyButton) {
        this.handleFrequencySelection(frequencyButton);
      } else {
        this.sellingPlanInput.value = '';
      }
    }

    this.updateFrequencyPrices();

    const initialVariantAvailable = String(this.variantIdInput?.dataset?.variantAvailable || 'true').toLowerCase() === 'true';
    this.setCtaOutOfStockState(initialVariantAvailable);
  }

  initPackForm() {
    if (!this.packForm) return;
    this.packSelect = this.packForm.querySelector('[data-pack-select]');
    this.packSelectTrigger = this.packForm.querySelector('[data-pack-select-trigger]');
    this.packSelectList = this.packForm.querySelector('[data-pack-select-list]');
    this.packSelectLabel = this.packForm.querySelector('[data-pack-select-label]');
    this.packSelectImage = this.packForm.querySelector('[data-pack-select-image]');
    this.packOptions = Array.from(this.packForm.querySelectorAll('[data-pack-option]'));
    this.packQuantityButtons = Array.from(this.packForm.querySelectorAll('[data-pack-quantity-button]'));
    this.packList = this.packForm.querySelector('[data-pack-list]');
    this.packEmpty = this.packForm.querySelector('[data-pack-empty]');
    this.packTemplates = Array.from(this.packForm.querySelectorAll('[data-pack-template]'));
    this.packProductsData = this.parsePackProductsData();
    this.packUnitLabel = this.packForm.dataset.packUnitLabel || '';
    this.packQuantityBadgeFirst = (this.packForm.dataset.packQuantityBadgeFirst || '').trim();
    this.packQuantityBadgeSecond = (this.packForm.dataset.packQuantityBadgeSecond || '').trim();
    this.packSelectedFormat = this.packForm.dataset.selectedFormat || this.packProductsData[0]?.format || '';
    this.packSelectedProductId = this.packForm.dataset.selectedPackProductId || String(this.packProductsData[0]?.productId || '');
    this.updatePackFormat(this.packSelectedFormat, false);
    this.updatePackQuantityButtons();
    this.setActivePackProduct(this.packSelectedProductId);
    this.updatePackProduct();
  }

  parsePackProductsData() {
    if (!this.packForm) return [];
    const jsonEl = this.packForm.querySelector('[data-pack-products-json]');
    if (!jsonEl) return [];
    try {
      const data = JSON.parse(jsonEl.textContent);
      return Array.isArray(data?.packs) ? data.packs : [];
    } catch (error) {
      return [];
    }
  }

  findPackProduct(productId) {
    return this.packProductsData.find((pack) => String(pack.productId) === String(productId));
  }

  togglePackSelect() {
    if (!this.packSelect) return;
    const isOpen = this.packSelect.classList.toggle('is-open');
    if (this.packSelectTrigger) {
      this.packSelectTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  closePackSelect() {
    if (!this.packSelect) return;
    this.packSelect.classList.remove('is-open');
    if (this.packSelectTrigger) {
      this.packSelectTrigger.setAttribute('aria-expanded', 'false');
    }
  }

  handlePackOption(button) {
    if (!button) return;
    const format = button.dataset.packFormat || '';
    if (!format) return;
    this.updatePackFormat(format, true);
  }

  handlePackQuantity(button) {
    if (!button || button.disabled) return;
    const productId = button.dataset.packProductId || '';
    if (!productId) return;
    this.setActivePackProduct(productId);
    this.updatePackProduct();
  }

  updatePackFormat(format, shouldUpdate) {
    this.packSelectedFormat = format;
    const activeOption = this.packOptions.find((option) => option.dataset.packFormat === format);
    this.packOptions.forEach((option) => {
      option.classList.toggle('is-active', option === activeOption);
    });

    if (this.packSelectLabel) {
      this.packSelectLabel.textContent = format;
    }

    if (this.packSelectImage) {
      const imageUrl = activeOption?.dataset?.packOptionImage || '';
      if (imageUrl) {
        this.packSelectImage.src = imageUrl;
        this.packSelectImage.hidden = false;
      } else {
        this.packSelectImage.removeAttribute('src');
        this.packSelectImage.hidden = true;
      }
    }

    this.syncStickyPackSummaryMedia();

    this.updatePackQuantityButtons();

    if (shouldUpdate) {
      const firstVisible = this.packQuantityButtons.find((btn) => !btn.hidden && !btn.disabled);
      const productId = firstVisible?.dataset.packProductId || '';
      this.setActivePackProduct(productId);
      this.updatePackProduct();
    }

    this.closePackSelect();
  }

  syncStickyPackSummaryMedia() {
    if (!this.stickySummaryImage || !this.packSelectImage) return;
    const imageUrl = this.packSelectImage.getAttribute('src') || '';
    if (!imageUrl) return;
    this.stickySummaryImage.src = imageUrl;
  }

  getPackDiscountPercent(productId) {
    if (!productId) return 0;
    const pack = this.findPackProduct(productId);
    if (!pack) return 0;

    const price = Number.parseInt(pack.price, 10);
    const compareAt = Number.parseInt(pack.compareAtPrice, 10);
    if (Number.isNaN(price) || price <= 0 || Number.isNaN(compareAt) || compareAt <= price) return 0;

    return Math.max(0, Math.round(((compareAt - price) / compareAt) * 100));
  }

  getPackQuantityBadgeText(button, visibleIndex) {
    const productId = button?.dataset?.packProductId || '';
    const manualText = visibleIndex === 1
      ? this.packQuantityBadgeFirst
      : (visibleIndex === 2 ? this.packQuantityBadgeSecond : '');
    const normalizedManualText = typeof manualText === 'string' ? manualText.trim() : '';
    if (normalizedManualText) return normalizedManualText;
    if (visibleIndex !== 1 && visibleIndex !== 2) return '';

    const discountPercent = this.getPackDiscountPercent(productId);
    return discountPercent > 0 ? `-${discountPercent}%` : '';
  }

  updatePackQuantityButtons() {
    const shouldFilterByFormat = Boolean(this.packSelect);
    let visibleIndex = 0;
    this.packQuantityButtons.forEach((button) => {
      const btnFormat = button.dataset.packFormat || '';
      const isFormatMatch = shouldFilterByFormat ? btnFormat === this.packSelectedFormat : true;
      if (isFormatMatch) {
        button.disabled = false;
        button.hidden = false;
        visibleIndex++;
        const badgeEl = button.querySelector('[data-pack-quantity-badge]');
        if (badgeEl) {
          const badgeText = this.getPackQuantityBadgeText(button, visibleIndex);
          badgeEl.hidden = badgeText === '';
          badgeEl.textContent = badgeText;
        }
      } else {
        button.disabled = true;
        button.hidden = true;
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
        const badgeEl = button.querySelector('[data-pack-quantity-badge]');
        if (badgeEl) {
          badgeEl.hidden = true;
          badgeEl.textContent = '';
        }
      }
    });
  }

  setActivePackProduct(productId) {
    this.packSelectedProductId = productId;
    this.packQuantityButtons.forEach((button) => {
      const isActive = button.dataset.packProductId === productId && !button.disabled && !button.hidden;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  updatePackProduct() {
    if (!this.packForm) return;
    const activeButton = this.packQuantityButtons.find((btn) => btn.classList.contains('is-active')) || this.packQuantityButtons.find((btn) => !btn.hidden && !btn.disabled);
    if (!activeButton) return;
    if (!activeButton.classList.contains('is-active')) {
      this.setActivePackProduct(activeButton.dataset.packProductId || '');
    }
    const productId = activeButton.dataset.packProductId;
    const pack = this.findPackProduct(productId);
    if (!pack) return;

    if (this.variantIdInput) {
      this.variantIdInput.value = String(pack.variantId);
    }

    if (this.quantityInput) {
      this.quantityInput.value = '1';
    }

    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = '';
    }

    this.updatePackList(productId);
    this.updatePackDescription(pack);
    this.updatePackIngredients(pack);
    this.updatePackTitle(pack);
    this.updateStickySummarySubtext(pack.stickyQuantitySize || '');

    const price = Number.parseInt(pack.price, 10);
    const compareAt = Number.parseInt(pack.compareAtPrice, 10);
    const comparePrice = Number.isNaN(compareAt) || compareAt <= price ? price : compareAt;
    const showCompare = comparePrice > price;

    if (this.ctaButton) {
      this.updateMainAndStickyCtaPrices(comparePrice, price, showCompare);
    }

    this.updateBundleProgress({ priceCents: price });

    if (pack.images && pack.images.length > 0) {
      this.updatePackGallery(pack.images);
    }

    const isPackAvailable = String(pack.available) !== 'false';
    this.setCtaOutOfStockState(isPackAvailable);
    this.dispatchPackChange(pack);
  }

  dispatchPackChange(pack) {
    const productId = String(pack?.productId || '');
    if (!productId) return;
    const faqQuestions = Array.isArray(pack?.faqQuestions) ? pack.faqQuestions : [];
    const faqAnswers = Array.isArray(pack?.faqAnswers) ? pack.faqAnswers : [];
    document.dispatchEvent(new CustomEvent('main-product:pack-change', {
      detail: {
        productId,
        faqQuestions,
        faqAnswers
      }
    }));
  }

  updatePackDescription(pack) {
    console.log(pack);
    if (!this.packDescriptionTargets.length) return;
    const hasPackDescription = typeof pack?.descriptionHtml === 'string' && pack.descriptionHtml.trim() !== '';
    const nextHtml = hasPackDescription ? pack.descriptionHtml : this.packDescriptionDefaultHTML;
    this.packDescriptionTargets.forEach((contentEl) => {
      contentEl.innerHTML = nextHtml;
    });
  }

  updatePackIngredients(pack) {
    if (!this.packIngredientsTargets.length) return;
    const hasPackIngredients = typeof pack?.ingredientsHtml === 'string' && pack.ingredientsHtml.trim() !== '';
    const nextHtml = hasPackIngredients ? pack.ingredientsHtml : this.packIngredientsDefaultHTML;
    this.packIngredientsTargets.forEach((contentEl) => {
      contentEl.innerHTML = nextHtml;
    });
  }

  updatePackTitle(pack) {
    document.querySelector('.main-product__title').innerHTML = pack.title;
  }

  updatePackGallery(images) {
    if (!this.mainEl || !this.thumbsEl || typeof Swiper === 'undefined') return;

    this.destroySwipers();

    const mainWrapper = this.mainEl.querySelector('.swiper-wrapper');
    const thumbsWrapper = this.thumbsEl.querySelector('.swiper-wrapper');
    if (!mainWrapper || !thumbsWrapper) return;

    mainWrapper.innerHTML = images.map((img) => `
      <div class="swiper-slide main-product__main-slide">
        <figure class="main-product__main-image-wrapper image-wrapper lazy-image lazy-image--backfill">
          <img src="${img.src}" srcset="${img.srcset}" sizes="(min-width: 989px) 663px, 100vw"
               alt="${img.alt}" loading="lazy" width="${img.width}" height="${img.height}"
               style="--aspect-ratio: 1;">
        </figure>
      </div>
    `).join('');

    thumbsWrapper.innerHTML = images.map((img, index) => `
      <div class="swiper-slide main-product__thumb-slide${index === 0 ? ' is-active' : ''}">
        <button type="button" class="main-product__thumb-button" data-slide-index="${index}"
                aria-label="${img.alt} - Image ${index + 1}" aria-current="${index === 0 ? 'true' : 'false'}">
          <figure class="main-product__thumb-image-wrapper image-wrapper lazy-image lazy-image--backfill">
            <img src="${img.thumbSrc}" srcset="${img.thumbSrcset}" sizes="(min-width: 989px) 72px, 88px"
                 alt="${img.alt}" loading="lazy" width="${img.width}" height="${img.height}"
                 style="--aspect-ratio: 1;">
          </figure>
        </button>
      </div>
    `).join('');

    this.thumbSlides = Array.from(this.thumbsEl.querySelectorAll('.main-product__thumb-slide'));

    const isDesktop = window.matchMedia(`(min-width: ${this.breakpoint}px)`).matches;
    this.initSwipers(isDesktop);
  }

  updatePackUnitPrice(button, pack) {
    const unitEl = button.querySelector('[data-pack-unit-price]');
    if (!unitEl) return;
    const unitPrice = Number.parseInt(pack.unitPrice, 10);
    if (!unitPrice || Number.isNaN(unitPrice)) {
      unitEl.textContent = '';
      unitEl.hidden = true;
      return;
    }
    const unitLabel = this.packUnitLabel ? ` / ${this.packUnitLabel}` : '';
    unitEl.textContent = `${this.formatMoney(unitPrice)}${unitLabel}`;
    unitEl.hidden = false;
  }

  clearPackUnitPrice(button) {
    const unitEl = button.querySelector('[data-pack-unit-price]');
    if (!unitEl) return;
    unitEl.textContent = '';
    unitEl.hidden = true;
  }

  updatePackList(productId) {
    if (!this.packList) return;
    const template = this.packTemplates.find((item) => String(item.dataset.packProductId) === String(productId));
    const html = template ? template.innerHTML.trim() : '';
    this.packList.innerHTML = html;
    if (this.packEmpty) {
      this.packEmpty.hidden = html.length > 0;
    }
  }

  initBundleBuilder() {
    if (!this.bundleForm) return;
    this.bundleTabs = Array.from(this.bundleForm.querySelectorAll('[data-bundle-tab]'));
    this.bundleCards = Array.from(this.bundleForm.querySelectorAll('[data-bundle-card]'));
    this.bundleGrid = this.bundleForm.querySelector('[data-bundle-products-grid]');
    this.bundleEmptyMessage = this.bundleForm.querySelector('.main-product-bundle-products__empty');
    this.bundleShowMoreButton = this.bundleForm.querySelector('[data-bundle-show-more]');
    this.bundleSelectedCount = this.bundleForm.querySelector('[data-bundle-selected-count]');
    this.bundleSelectedSummary = this.bundleForm.querySelector('[data-bundle-selected-summary]');
    this.bundleSelectedList = this.bundleForm.querySelector('[data-bundle-selected-list]');
    this.bundleHeadingPriceCompare = this.bundleForm.querySelector('[data-bundle-heading-price-compare]');
    this.bundleHeadingPrice = this.bundleForm.querySelector('[data-bundle-heading-price]');
    this.bundleActiveFilter = 'all';
    this.bundleExpanded = false;
    this.bundleMinProducts = Math.max(1, this.parseProgressInteger(this.bundleForm.dataset.bundleMinProducts || '', 4));
    this.bundleInitialLimit = this.parseProgressInteger(this.bundleForm.dataset.bundleInitialLimit || '', 8);
    this.bundleShowMoreLabel = this.bundleForm.dataset.bundleShowMoreLabel || 'Afficher plus de produits';
    this.bundleShowLessLabel = this.bundleForm.dataset.bundleShowLessLabel || 'Afficher moins de produits';

    const unavailableCards = this.bundleCards.filter((card) => String(card.dataset.bundleAvailable || '').toLowerCase() !== 'true');
    unavailableCards.forEach((card) => {
      card.remove();
    });
    this.bundleCards = Array.from(this.bundleForm.querySelectorAll('[data-bundle-card]'));
    if (this.bundleEmptyMessage) {
      this.bundleEmptyMessage.hidden = this.bundleCards.length > 0;
    }

    this.bundleCards.forEach((card) => {
      this.setBundleCardQuantity(card, 0, false);
    });

    this.updateBundleTabCounts();
    this.applyBundleFilter('all', { animate: false });
    this.updateBundleSelectionUI();
    this.prefillBundleFromCartAsync();
  }

  async prefillBundleFromCartAsync() {
    try {
      const items = await this.fetchCartBundleItems();
      if (!items.length) return;

      this.applyCartItemsToBuilder(items);

      const subscriptionItem = items.find((item) => item.sellingPlanId);
      if (subscriptionItem && this.subscriptionButton) {
        const planName = (subscriptionItem.sellingPlanName || '').trim().toLowerCase();
        const planButtons = Array.from(
          this.querySelectorAll('.main-product-form-block__subscription-plan-button')
        );
        const matchedButton = planButtons.find(
          (btn) => btn.textContent.trim().toLowerCase() === planName
        );
        if (matchedButton) {
          this.handleSubscriptionPlanSelection(matchedButton);
        } else {
          this.handleFrequencySelection(this.subscriptionButton);
        }
      } else if (!subscriptionItem && this.oneTimeButton) {
        this.handleFrequencySelection(this.oneTimeButton);
      }
    } catch (err) {
      console.warn('[MainProduct] prefillBundleFromCartAsync error:', err);
    }
  }

  handleBundleTab(button) {
    if (!button) return;
    const filter = (button.dataset.bundleFilter || 'all').trim().toLowerCase();
    this.bundleTabs.forEach((tab) => {
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    this.bundleExpanded = false;
    this.applyBundleFilter(filter || 'all');
  }

  toggleBundleShowMore() {
    this.bundleExpanded = !this.bundleExpanded;
    this.applyBundleFilter(this.bundleActiveFilter || 'all');
  }

  handleBundleAdd(button) {
    const card = button.closest('[data-bundle-card]');
    if (!card) return;
    this.setBundleCardQuantity(card, 1);
  }

  handleBundleDelta(button, delta) {
    const card = button.closest('[data-bundle-card]');
    if (!card) return;
    const currentQty = this.parseProgressInteger(card.dataset.bundleQty || '', 0);
    const nextQty = Math.max(0, currentQty + delta);
    this.setBundleCardQuantity(card, nextQty);
  }

  setBundleCardQuantity(card, quantity, shouldUpdate = true) {
    if (!card) return;
    const previousQty = this.parseProgressInteger(card.dataset.bundleQty || '', 0);
    const safeQty = Math.max(0, this.parseProgressInteger(quantity, 0));
    card.dataset.bundleQty = String(safeQty);
    card.classList.toggle('is-selected', safeQty > 0);

    if (safeQty > 0 && previousQty <= 0) {
      const selectedCollectionId = this.resolveBundleCardCollectionId(card, this.bundleActiveFilter || 'all');
      if (selectedCollectionId) {
        card.dataset.bundleSelectedCollectionId = String(selectedCollectionId);
      }
    }

    if (safeQty <= 0) {
      delete card.dataset.bundleSelectedCollectionId;
    }

    const qtyEl = card.querySelector('[data-bundle-qty]');
    if (qtyEl) {
      qtyEl.textContent = String(safeQty);
    }

    const addButton = card.querySelector('[data-bundle-add]');
    const stepper = card.querySelector('[data-bundle-stepper]');
    if (addButton) addButton.hidden = safeQty > 0;
    if (stepper) stepper.hidden = safeQty <= 0;

    if (shouldUpdate) {
      this.updateBundleSelectionUI();
    }
  }

  updateBundleTabCounts() {
    if (!this.bundleTabs.length) return;
    this.bundleTabs.forEach((tab) => {
      const filter = (tab.dataset.bundleFilter || 'all').trim().toLowerCase();
      const baseLabel = tab.dataset.bundleTabLabel || '';
      const textEl = tab.querySelector('[data-bundle-tab-text]');
      if (!textEl) return;
      if (filter === 'all') {
        textEl.textContent = `${baseLabel} (${this.bundleCards.length})`;
        return;
      }
      textEl.textContent = baseLabel;
    });
  }

  applyBundleFilter(filter = 'all', options = {}) {
    const animate = options.animate !== false;
    const startHeight = animate && this.bundleGrid ? this.bundleGrid.getBoundingClientRect().height : null;
    const canCollapseOnCurrentViewport = window.innerWidth >= this.breakpoint;
    this.bundleActiveFilter = filter;
    let matchedCount = 0;
    let visibleIndex = 0;

    this.bundleCards.forEach((card) => {
      const isMatching = this.bundleCardMatchesFilter(card, filter);
      card.classList.toggle('is-filter-hidden', !isMatching);
      if (!isMatching) {
        card.classList.add('is-collapsed-hidden');
        return;
      }

      const isCollapsed = canCollapseOnCurrentViewport && !this.bundleExpanded && visibleIndex >= this.bundleInitialLimit;
      card.classList.toggle('is-collapsed-hidden', isCollapsed);
      visibleIndex += 1;
      matchedCount += 1;
    });

    if (this.bundleShowMoreButton) {
      const canCollapse = canCollapseOnCurrentViewport && matchedCount > this.bundleInitialLimit;
      this.bundleShowMoreButton.hidden = !canCollapse;
      this.bundleShowMoreButton.textContent = this.bundleExpanded ? this.bundleShowLessLabel : this.bundleShowMoreLabel;
    }

    if (animate) {
      this.animateBundleGridHeight(startHeight);
    }
  }

  animateBundleGridHeight(startHeight) {
    if (!this.bundleGrid || !Number.isFinite(startHeight)) return;

    const targetHeight = this.bundleGrid.getBoundingClientRect().height;
    if (Math.abs(targetHeight - startHeight) < 1) return;

    this.bundleGrid.classList.add('is-animating-height');
    this.bundleGrid.style.height = `${startHeight}px`;
    this.bundleGrid.getBoundingClientRect();
    this.bundleGrid.style.height = `${targetHeight}px`;

    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'height') return;
      this.bundleGrid.classList.remove('is-animating-height');
      this.bundleGrid.style.height = '';
      this.bundleGrid.removeEventListener('transitionend', onTransitionEnd);
    };

    this.bundleGrid.addEventListener('transitionend', onTransitionEnd);
  }

  bundleCardMatchesFilter(card, filter = 'all') {
    if (!card) return false;
    if (!filter || filter === 'all') return true;
    const tagsSource = (card.dataset.bundleTags || '').toLowerCase();
    const tags = tagsSource.split('|').map((item) => item.trim()).filter(Boolean);
    return tags.includes(filter);
  }

  updateBundleSelectionUI() {
    if (!this.bundleCards.length) return;
    let totalQty = 0;
    let totalPriceCents = 0;
    const selectedItems = [];
    // Tableau temporaire reconstruit a chaque update :
    // il contient les produits selectionnes avec leurs IDs (produit + variante), quantite, prix, etc.
    const selectedSelections = [];

    this.bundleCards.forEach((card) => {
      const qty = this.parseProgressInteger(card.dataset.bundleQty || '', 0);
      if (qty <= 0) return;

      const title = (card.dataset.bundleProductTitle || '').trim();
      const priceCents = this.parseProgressInteger(card.dataset.bundlePriceCents || '', 0);
      const productId = this.parseProgressInteger(card.dataset.bundleProductId || '', 0);
      const variantId = this.parseProgressInteger(card.dataset.bundleVariantId || '', 0);
      const collectionId = this.parseProgressInteger(
        card.dataset.bundleSelectedCollectionId || this.resolveBundleCardCollectionId(card, this.bundleActiveFilter || 'all') || '',
        0
      );
      const childSellingPlanId = this.parseProgressInteger(card.dataset.bundleSellingPlanId || '', 0);
      const childSellingPlans = this.parseBundleSellingPlans(card.dataset.bundleSellingPlans || '');
      const available = String(card.dataset.bundleAvailable || '').toLowerCase() === 'true';
      const handle = (card.dataset.bundleProductHandle || '').trim();
      const weight = card.querySelector('.main-product-bundle-card__weight')?.textContent?.trim() || '';
      const imageEl = card.querySelector('.main-product-bundle-card__media img');
      const imageSrc = imageEl?.getAttribute('src') || '';
      const imageAlt = imageEl?.getAttribute('alt') || title;
      totalQty += qty;
      totalPriceCents += priceCents * qty;

      selectedSelections.push({
        productId: productId || null,
        variantId: variantId || null,
        collectionId: collectionId || null,
        sellingPlanId: childSellingPlanId || null,
        sellingPlans: childSellingPlans,
        handle,
        title,
        quantity: qty,
        priceCents,
        available,
        imageSrc,
        imageAlt,
        weight
      });

      if (title) {
        selectedItems.push(`${title} (${qty})`);
      }
    });

    // Etat du bundle pour la suite (CTA / envoi panier / integration Recharge).
    this.bundleSelections = selectedSelections;
    // Version simplifiee : tableau des IDs produits selectionnes uniquement.
    this.bundleSelectedProductIds = selectedSelections
      .map((item) => item.productId)
      .filter((id) => Number.isFinite(id) && id > 0);

    if (this.bundleForm) {
      this.bundleForm.dataset.bundleSelectedProductIds = JSON.stringify(this.bundleSelectedProductIds);
      this.bundleForm.dataset.bundleSelections = JSON.stringify(this.bundleSelections);
    }

    if (this.bundleSelectedCount) {
      this.bundleSelectedCount.textContent = String(totalQty);
    }

    if (this.stickyBundleTotal) {
      this.stickyBundleTotal.textContent = String(Math.max(0, totalQty));
    }

    if (this.bundleSelectedSummary && this.bundleSelectedList) {
      const hasSelection = selectedItems.length > 0;
      this.bundleSelectedSummary.hidden = !hasSelection;
      this.bundleSelectedList.textContent = hasSelection ? selectedItems.join(' — ') : '';
    }

    this.renderStickyBundleItems();
    this.updateStickyBundleMobileUI(totalQty, totalPriceCents);
    this.updateCtaBundleState(totalQty);
    this.updateStickyVisibility();

    this.updateBundleProgress({ priceCents: totalPriceCents, quantity: totalQty });
    this.updateFrequencyPrices();

    this.dispatchEvent(new CustomEvent('main-product:bundle-selection-change', {
      bubbles: true,
      detail: {
        items: this.bundleSelections,
        productIds: this.bundleSelectedProductIds,
        totalQty,
        totalPriceCents
      }
    }));
  }

  setBundleCtaLoading(isLoading) {
    const loading = Boolean(isLoading);
    this.bundleSubmitPending = loading;
    if (this.ctaButton) {
      this.ctaButton.disabled = loading;
      this.ctaButton.classList.toggle('is-loading', loading);
      this.ctaButton.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
    if (this.stickyCtaButton) {
      this.stickyCtaButton.disabled = loading;
      this.stickyCtaButton.classList.toggle('is-loading', loading);
      this.stickyCtaButton.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  }

  getBundleCardCollectionEntries(card) {
    if (!card) return [];
    const handles = String(card.dataset.bundleTags || '')
      .toLowerCase()
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean);
    const ids = String(card.dataset.bundleCollectionIds || '')
      .split('|')
      .map((item) => item.trim());

    const entries = [];
    handles.forEach((handle, index) => {
      const collectionId = this.parseProgressInteger(ids[index] || '', 0);
      if (!handle || collectionId <= 0) return;
      entries.push({ handle, collectionId });
    });

    return entries;
  }

  resolveBundleCardCollectionId(card, preferredFilter = 'all') {
    const entries = this.getBundleCardCollectionEntries(card);
    if (!entries.length) return null;

    if (preferredFilter && preferredFilter !== 'all') {
      const matched = entries.find((entry) => entry.handle === String(preferredFilter).toLowerCase());
      if (matched?.collectionId) return matched.collectionId;
    }

    return entries[0]?.collectionId || null;
  }

  isBundleSubscriptionSelected() {
    const activeFrequencyButton = this.querySelector('.main-product-form-block__frequency-button.is-active');
    return activeFrequencyButton?.dataset?.frequency === 'subscription';
  }

  getBundleParentSellingPlanId() {
    const selectedPlanId = this.parseProgressInteger(this.sellingPlanInput?.value || '', 0);
    if (selectedPlanId > 0) return selectedPlanId;

    // Fallback simple : sur ce template bundle il n'y a qu'un seul abonnement,
    // donc on reprend le premier selling_plan expose par Liquid si l'input hidden est vide.
    const fallbackPlanId = this.parseProgressInteger(this.bundleForm?.dataset?.bundleParentFirstSellingPlanId || '', 0);
    return fallbackPlanId > 0 ? fallbackPlanId : null;
  }

  parseBundleSellingPlans(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((plan) => ({
          id: this.parseProgressInteger(plan?.id, 0),
          name: String(plan?.name || '').trim(),
          price: this.parseProgressInteger(plan?.price, 0),
          compareAtPrice: this.parseProgressInteger(plan?.compareAtPrice, 0)
        }))
        .filter((plan) => plan.id > 0);
    } catch (error) {
      return [];
    }
  }

  normalizeSellingPlanName(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  getActiveSubscriptionPlanMeta() {
    const selector = this.frequencySelector || this.querySelector('[data-frequency-selector]');
    if (!selector) return null;
    const selectedPlanButton = selector.querySelector('.main-product-form-block__subscription-plan-button.is-active')
      || selector.querySelector('.main-product-form-block__subscription-plan-button');
    if (!selectedPlanButton) return null;

    const id = this.parseProgressInteger(selectedPlanButton.dataset.sellingPlanChoiceId || '', 0);
    const name = selectedPlanButton.textContent?.trim() || '';
    return {
      id: id > 0 ? id : null,
      name,
      normalizedName: this.normalizeSellingPlanName(name)
    };
  }

  resolveBundleChildSellingPlanId(item, activePlanMeta) {
    if (!item) return 0;

    const itemPlans = Array.isArray(item.sellingPlans) ? item.sellingPlans : [];
    const fallbackPlanId = this.parseProgressInteger(item.sellingPlanId, 0);

    if (!itemPlans.length) {
      return fallbackPlanId;
    }

    if (activePlanMeta?.id) {
      const sameIdPlan = itemPlans.find((plan) => this.parseProgressInteger(plan.id, 0) === activePlanMeta.id);
      if (sameIdPlan) return this.parseProgressInteger(sameIdPlan.id, 0);
    }

    if (activePlanMeta?.normalizedName) {
      const sameNamePlan = itemPlans.find((plan) => this.normalizeSellingPlanName(plan.name) === activePlanMeta.normalizedName);
      if (sameNamePlan) return this.parseProgressInteger(sameNamePlan.id, 0);
    }

    return fallbackPlanId;
  }

  resolveBundleChildSellingPlan(item, activePlanMeta) {
    if (!item) return null;
    const itemPlans = Array.isArray(item.sellingPlans) ? item.sellingPlans : [];
    if (!itemPlans.length) return null;

    if (activePlanMeta?.id) {
      const match = itemPlans.find((plan) => this.parseProgressInteger(plan.id, 0) === activePlanMeta.id);
      if (match) return match;
    }

    if (activePlanMeta?.normalizedName) {
      const match = itemPlans.find((plan) => this.normalizeSellingPlanName(plan.name) === activePlanMeta.normalizedName);
      if (match) return match;
    }

    return itemPlans[0] || null;
  }

  buildRechargeDynamicBundlePayload() {
    if (!this.bundleForm) {
      throw new Error('Bundle form introuvable.');
    }

    const selectedQty = this.getBundleSelectedQuantity();
    if (!this.isBundleMinimumReached(selectedQty)) {
      throw new Error(this.getBundleMinimumMessage(selectedQty));
    }

    if (!this.bundleSelections.length) {
      throw new Error('Aucun produit sélectionné dans le bundle.');
    }

    const unavailableItems = this.bundleSelections.filter((item) => item && item.available === false);
    if (unavailableItems.length) {
      throw new Error('Un ou plusieurs produits du bundle sont indisponibles.');
    }

    const externalProductId = this.parseProgressInteger(this.bundleForm.dataset.bundleParentProductId || '', 0);
    const externalVariantId = this.parseProgressInteger(this.variantIdInput?.value || '', 0);
    const bundleHandle = String(this.bundleForm.dataset.bundleParentProductHandle || '').trim();

    if (!externalProductId || !externalVariantId || !bundleHandle) {
      throw new Error('Informations du produit bundle parent manquantes (productId / variantId / handle).');
    }

    const isSubscription = this.isBundleSubscriptionSelected();
    const parentSellingPlanId = isSubscription ? this.getBundleParentSellingPlanId() : null;
    const activeSubscriptionPlanMeta = isSubscription ? this.getActiveSubscriptionPlanMeta() : null;

    if (isSubscription && !parentSellingPlanId) {
      throw new Error('Selling plan du bundle parent introuvable.');
    }

    // Construction du tableau "selections" attendu par Recharge (dynamic-priced bundle).
    // Chaque ligne doit contenir les IDs Shopify (produit + variante), la collection Recharge/Shopify source,
    // la quantite, et le selling plan si l'utilisateur choisit l'abonnement.
    const selections = this.bundleSelections.map((item) => {
      const selection = {
        externalProductId: this.parseProgressInteger(item.productId, 0),
        externalVariantId: this.parseProgressInteger(item.variantId, 0),
        collectionId: String(item.collectionId || ''),
        quantity: this.parseProgressInteger(item.quantity, 0)
      };

      if (!selection.externalProductId || !selection.externalVariantId || !selection.collectionId || selection.quantity <= 0) {
        throw new Error(`Selection bundle invalide pour le produit "${item?.title || item?.handle || 'inconnu'}".`);
      }

      if (isSubscription) {
        const childSellingPlanId = this.resolveBundleChildSellingPlanId(item, activeSubscriptionPlanMeta);
        if (!childSellingPlanId) {
          throw new Error(`Selling plan introuvable pour "${item?.title || item?.handle || 'un produit du bundle'}".`);
        }
        selection.sellingPlan = childSellingPlanId;
      }

      return selection;
    });

    return {
      bundleHandle,
      isSubscription,
      parentSellingPlanId,
      bundle: {
        externalProductId,
        externalVariantId,
        selections
      }
    };
  }

  async submitBundleWithRechargeDynamic() {
    this.setBundleCtaLoading(true);

    try {
      if (!window.recharge?.bundle?.validateDynamicBundle || !window.recharge?.bundle?.getDynamicBundleItems) {
        throw new Error('Recharge SDK bundle indisponible sur cette page.');
      }

      try {
        await this.removeExistingBundleFromCart();
        await new Promise((resolve) => window.setTimeout(resolve, 1500));
      } catch (err) {
        console.warn('[MainProduct] removeExistingBundleFromCart failed, continuing:', err);
      }

      const { bundle, bundleHandle } = this.buildRechargeDynamicBundlePayload();

      const isValid = await window.recharge.bundle.validateDynamicBundle(bundle);
      if (!isValid) {
        throw new Error('Validation Recharge du bundle échouée.');
      }

      const dynamicCartItems = await window.recharge.bundle.getDynamicBundleItems(bundle, bundleHandle);
      if (!Array.isArray(dynamicCartItems) || !dynamicCartItems.length) {
        throw new Error('Recharge n\'a retourne aucun item panier pour ce bundle.');
      }

      const response = await this.addItemsToCartWithRetry(dynamicCartItems);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Échec add-to-cart (${response.status}) : ${errorText}`);
      }

      try {
        await response.json();
      } catch (error) {
        // Reponse JSON non critique : certains environnements/theme apps renvoient autre chose.
      }

      // On aligne le comportement bundle sur les autres templates :
      // mise a jour + ouverture du side-cart du theme (au lieu d'une redirection /cart).
      this.refreshAndOpenThemeCartDrawer();
    } finally {
      this.bundleSubmitPending = false;
    }
  }

  async addItemsToCartWithRetry(items, maxAttempts = 3) {
    let lastResponse = null;

    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });

      if (response.ok) {
        return response;
      }

      lastResponse = response;

      // Shopify / Cloudflare peut retourner 429 avec une page HTML de verification
      // en preview si trop de requetes AJAX sont envoyees. On retente une fois.
      if (response.status !== 429 || attempt >= maxAttempts) {
        return response;
      }

      await new Promise((resolve) => window.setTimeout(resolve, 1500 * attempt));
    }

    return lastResponse;
  }

  onBundleProgressExternalUpdate(event) {
    if (!event || !event.detail) return;
    const detail = event.detail;
    const parsedPrice = Number(detail.priceCents);
    const parsedQuantity = Number(detail.quantity);
    const priceCents = Number.isFinite(parsedPrice) ? parsedPrice : undefined;
    const quantity = Number.isFinite(parsedQuantity) ? parsedQuantity : undefined;
    this.updateBundleProgress({ priceCents, quantity });
  }

  initBundleProgress() {
    const progressEls = Array.from(this.querySelectorAll('[data-bundle-progress]'));
    if (!progressEls.length) {
      this.bundleProgressItems = [];
      this.teardownBundleProgressStickyState();
      return;
    }

    this.bundleProgressItems = progressEls
      .map((el) => this.parseBundleProgressItem(el))
      .filter(Boolean);

    this.bundleProgressItems.forEach((item) => this.renderBundleProgressItem(item));
    this.updateBundleProgress();
    this.initBundleProgressStickyState();
    this.syncBundleProgressPlacement();
  }

  initBundleProgressStickyState() {
    this.teardownBundleProgressStickyState();
    this.bundleProgressStickyTargets = this.bundleProgressItems
      .map((item) => item?.el)
      .filter((el) => el instanceof HTMLElement);

    if (!this.bundleProgressStickyTargets.length) return;

    window.addEventListener('scroll', this.onBundleProgressStickyScroll, { passive: true });
    window.addEventListener('resize', this.onBundleProgressStickyResize);
    document.addEventListener('theme:resize:width', this.onBundleProgressStickyResize);
    this.bundleProgressStickyListening = true;
    this.updateBundleProgressStickyState();
  }

  teardownBundleProgressStickyState() {
    if (this.bundleProgressStickyListening) {
      window.removeEventListener('scroll', this.onBundleProgressStickyScroll);
      window.removeEventListener('resize', this.onBundleProgressStickyResize);
      document.removeEventListener('theme:resize:width', this.onBundleProgressStickyResize);
      this.bundleProgressStickyListening = false;
    }
    this.bundleProgressStickyTargets.forEach((el) => {
      el.classList.remove('is-stuck');
    });
    this.bundleProgressStickyTargets = [];
    this.bundleProgressStickyTicking = false;
  }

  onBundleProgressStickyScroll() {
    if (this.bundleProgressStickyTicking) return;
    this.bundleProgressStickyTicking = true;
    window.requestAnimationFrame(() => {
      this.bundleProgressStickyTicking = false;
      this.updateBundleProgressStickyState();
    });
  }

  onBundleProgressStickyResize() {
    this.syncBundleProgressPlacement();
    this.updateBundleProgressStickyState();
  }

  syncBundleProgressPlacement() {
    if (!this.bundleForm) return;

    const progressEl = this.querySelector('[data-bundle-progress]');
    if (!(progressEl instanceof HTMLElement)) return;

    if (!this.bundleProgressOriginalParent) {
      this.bundleProgressOriginalParent = progressEl.parentElement;
      this.bundleProgressOriginalNextSibling = progressEl.nextElementSibling;
    }

    progressEl.classList.remove('is-inside-sticky');

    if (!this.bundleProgressOriginalParent) return;

    if (progressEl.parentElement !== this.bundleProgressOriginalParent) {
      const next = this.bundleProgressOriginalNextSibling;
      if (next && next.parentElement === this.bundleProgressOriginalParent) {
        this.bundleProgressOriginalParent.insertBefore(progressEl, next);
      } else {
        this.bundleProgressOriginalParent.appendChild(progressEl);
      }
    }

    const shouldDuplicateInSticky = Boolean(
      this.stickyBundleProgressHost
      && this.stickyBar?.classList.contains('is-bundle')
      && window.innerWidth < this.breakpoint
    );

    if (shouldDuplicateInSticky) {
      this.syncStickyBundleProgressClone(progressEl);
      return;
    }

    this.removeStickyBundleProgressClone();
  }

  syncStickyBundleProgressClone(originalEl) {
    if (!this.stickyBundleProgressHost || !(originalEl instanceof HTMLElement)) return;

    let cloneEl = this.stickyBundleProgressHost.querySelector('[data-bundle-progress-clone]');
    if (!(cloneEl instanceof HTMLElement)) {
      cloneEl = originalEl.cloneNode(true);
      cloneEl.removeAttribute('data-bundle-progress');
      cloneEl.setAttribute('data-bundle-progress-clone', '');
      this.stickyBundleProgressHost.innerHTML = '';
      this.stickyBundleProgressHost.appendChild(cloneEl);
    }

    cloneEl.className = originalEl.className;
    cloneEl.classList.remove('is-stuck');
    cloneEl.classList.add('is-inside-sticky');
    cloneEl.innerHTML = originalEl.innerHTML;
  }

  removeStickyBundleProgressClone() {
    if (!this.stickyBundleProgressHost) return;
    const cloneEl = this.stickyBundleProgressHost.querySelector('[data-bundle-progress-clone]');
    if (cloneEl) {
      cloneEl.remove();
    }
  }

  updateBundleProgressStickyState() {
    if (!this.bundleProgressStickyTargets.length) return;
    const isMobile = window.innerWidth < this.breakpoint;
    this.bundleProgressStickyTargets.forEach((el) => {
      if (isMobile) {
        el.classList.remove('is-stuck');
        return;
      }
      if (el.classList.contains('is-inside-sticky')) {
        el.classList.remove('is-stuck');
        return;
      }
      const rect = el.getBoundingClientRect();
      const computedTop = Number.parseFloat(window.getComputedStyle(el).top);
      const stickyTop = Number.isNaN(computedTop) ? this.getBundleProgressStickyTopOffset() : computedTop;
      const isStuck = rect.top <= (stickyTop + 0.5);
      el.classList.toggle('is-stuck', isStuck);
    });
  }

  getBundleProgressStickyTopOffset() {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const headerStickyHeight = Number.parseFloat(rootStyles.getPropertyValue('--header-sticky-height')) || 0;
    const announcementHeight = Number.parseFloat(rootStyles.getPropertyValue('--announcement-height')) || 0;
    return headerStickyHeight + announcementHeight;
  }

  parseBundleProgressItem(el) {
    if (!el) return null;
    const valuesEl = el.querySelector('[data-bundle-progress-values]');
    const pointsEl = el.querySelector('[data-bundle-progress-points]');
    const labelsEl = el.querySelector('[data-bundle-progress-labels]');
    const fillEl = el.querySelector('[data-bundle-progress-fill]');
    const stepsJsonEl = el.querySelector('[data-bundle-progress-steps]');
    if (!valuesEl || !pointsEl || !labelsEl || !fillEl || !stepsJsonEl) return null;

    let rawSteps = [];
    try {
      const parsed = JSON.parse(stepsJsonEl.textContent || '[]');
      rawSteps = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      rawSteps = [];
    }

    const rawStepCount = Number.parseInt(el.dataset.stepCount || '', 10);
    const stepCount = Number.isNaN(rawStepCount) ? 4 : Math.min(Math.max(rawStepCount, 2), 6);
    const mode = el.dataset.mode === 'quantity' ? 'quantity' : 'price';
    const qtyUnit = (el.dataset.qtyUnit || '').trim();
    const defaultPriceCents = this.parseProgressPriceToCents(el.dataset.currentPrice || '');
    const defaultQuantity = this.parseProgressInteger(el.dataset.currentQty || '', 0);

    const steps = rawSteps
      .slice(0, stepCount)
      .map((step) => ({
        targetPriceCents: this.parseProgressPriceToCents(step?.price),
        targetQty: this.parseProgressInteger(step?.qty, 0),
        label: String(step?.label || '').trim()
      }));

    if (!steps.length) return null;

    return {
      el,
      valuesEl,
      pointsEl,
      labelsEl,
      fillEl,
      mode,
      qtyUnit,
      steps,
      valueItems: [],
      pointItems: [],
      labelItems: [],
      defaultPriceCents,
      defaultQuantity
    };
  }

  renderBundleProgressItem(item) {
    if (!item) return;
    item.valuesEl.innerHTML = '';
    item.pointsEl.innerHTML = '';
    item.labelsEl.innerHTML = '';
    item.valueItems = [];
    item.pointItems = [];
    item.labelItems = [];
    item.el.style.setProperty('--bundle-progress-steps', `${item.steps.length}`);

    item.steps.forEach((step, index) => {
      const pointPosition = this.getBundlePointPosition(index, item.steps.length);

      const valueItem = document.createElement('span');
      valueItem.className = 'main-product-bundle-progress__value';
      item.valuesEl.appendChild(valueItem);
      item.valueItems.push(valueItem);

      const pointItem = document.createElement('span');
      pointItem.className = 'main-product-bundle-progress__point is-locked';
      pointItem.style.left = `${pointPosition}%`;
      pointItem.innerHTML = `
        <span class="main-product-bundle-progress__point-check" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
            <path d="M2.99081 4.32006L7.31089 0L7.97551 0.664624L2.99081 5.6493L0 2.65851L0.664629 1.9939L2.99081 4.32006Z" fill="white"/>
          </svg>
        </span>
        <span class="main-product-bundle-progress__point-lock" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none">
            <path d="M2.71831 0C2.75109 0 2.78916 0.0193851 2.82035 0.0246719C3.76828 0.181867 4.45363 1.00291 4.45345 1.96512V2.62298C4.74952 2.61945 4.98038 2.84767 4.98055 3.14179L4.98284 5.94064C4.98302 6.18049 4.81578 6.47567 4.53681 6.47567L0.443566 6.47602C0.18081 6.47602 0 6.19635 0 5.96619V3.14161C0 2.83709 0.247776 2.605 0.557585 2.62368L0.558819 1.96494C0.560757 0.929602 1.30373 0.142745 2.30048 0H2.71831ZM3.5991 2.62262L3.59998 1.95102C3.60069 1.34198 3.10848 0.854176 2.50984 0.851885C1.91472 0.849594 1.41123 1.33017 1.41159 1.93851V2.62315L3.5991 2.6228V2.62262ZM2.26559 5.40226C2.26559 5.53778 2.3641 5.63647 2.48851 5.64564C2.60148 5.65392 2.73858 5.58061 2.73946 5.45038L2.74493 4.77437C2.74528 4.73048 2.76378 4.70053 2.79779 4.67585C2.94353 4.57065 3.00874 4.40129 2.98336 4.2203C2.96133 4.06381 2.85524 3.92266 2.6977 3.85357C2.51248 3.77233 2.30788 3.81181 2.16478 3.95455C1.95419 4.16462 1.97728 4.50438 2.21783 4.68061C2.24832 4.70299 2.26611 4.73595 2.26611 4.77542L2.26541 5.40226H2.26559Z" fill="#FF6C0E"/>
          </svg>
        </span>
      `;
      item.pointsEl.appendChild(pointItem);
      item.pointItems.push(pointItem);

      const labelItem = document.createElement('span');
      labelItem.className = 'main-product-bundle-progress__label';
      labelItem.textContent = step.label;
      item.labelsEl.appendChild(labelItem);
      item.labelItems.push(labelItem);
    });
  }

  updateBundleProgress(state = {}) {
    if (!this.bundleProgressItems || !this.bundleProgressItems.length) return;

    const hasPrice = Number.isFinite(state.priceCents);
    const hasQuantity = Number.isFinite(state.quantity);
    const sharedPriceCents = hasPrice ? Math.max(0, Math.round(state.priceCents)) : this.getBundleCurrentPrice();
    const sharedQuantity = hasQuantity ? Math.max(0, Math.round(state.quantity)) : this.getBundleCurrentQuantity();

    this.bundleProgressItems.forEach((item) => {
      const currentValue = item.mode === 'quantity' ? sharedQuantity : sharedPriceCents;
      const targets = item.steps.map((step) => (item.mode === 'quantity' ? step.targetQty : step.targetPriceCents));
      const fillPercent = this.getBundleProgressFillPercent(currentValue, targets);
      item.fillEl.style.width = `${fillPercent}%`;

      let currentIndex = -1;
      item.steps.forEach((step, index) => {
        const target = item.mode === 'quantity' ? step.targetQty : step.targetPriceCents;
        const achieved = target > 0 && currentValue >= target;
        if (!achieved && currentIndex === -1) {
          currentIndex = index;
        }

        const valueText = item.mode === 'quantity'
          ? this.formatBundleQuantity(step.targetQty, item.qtyUnit)
          : this.formatMoney(step.targetPriceCents);

        if (item.valueItems[index]) {
          item.valueItems[index].textContent = valueText;
          item.valueItems[index].classList.toggle('is-achieved', achieved);
        }

        if (item.labelItems[index]) {
          item.labelItems[index].classList.toggle('is-achieved', achieved);
        }

        if (item.pointItems[index]) {
          item.pointItems[index].classList.toggle('is-achieved', achieved);
          item.pointItems[index].classList.toggle('is-locked', !achieved);
          item.pointItems[index].classList.remove('is-current');
        }
      });

      if (currentIndex === -1 && item.pointItems.length) {
        currentIndex = item.pointItems.length - 1;
      }
      if (currentIndex >= 0 && item.pointItems[currentIndex] && !item.pointItems[currentIndex].classList.contains('is-achieved')) {
        item.pointItems[currentIndex].classList.add('is-current');
      }
    });

    this.syncBundleProgressPlacement();
  }

  parseProgressPriceToCents(value) {
    if (value === null || value === undefined) return 0;
    const normalized = String(value)
      .trim()
      .replace(/\s+/g, '')
      .replace(',', '.')
      .replace(/[^0-9.]/g, '');
    if (!normalized) return 0;
    const amount = Number.parseFloat(normalized);
    if (Number.isNaN(amount)) return 0;
    return Math.max(0, Math.round(amount * 100));
  }

  parseProgressInteger(value, fallback = 0) {
    const parsed = Number.parseInt(String(value ?? ''), 10);
    if (Number.isNaN(parsed)) return fallback;
    return parsed;
  }

  formatBundleQuantity(value, unit) {
    const qty = Number.isFinite(value) && value > 0 ? value : 0;
    if (!unit) return `${qty}`;
    return `${qty} ${unit}`;
  }

  getBundleCurrentPrice() {
    const firstProgress = this.bundleProgressItems[0];
    if (firstProgress && Number.isFinite(firstProgress.defaultPriceCents)) {
      return Math.max(0, firstProgress.defaultPriceCents);
    }

    return 0;
  }

  getBundleCurrentQuantity() {
    const firstProgress = this.bundleProgressItems[0];
    if (firstProgress && Number.isFinite(firstProgress.defaultQuantity) && firstProgress.defaultQuantity > 0) {
      return firstProgress.defaultQuantity;
    }

    return 0;
  }

  getBundleProgressFillPercent(currentValue, targets) {
    if (!targets.length) return 0;
    const current = Number.isFinite(currentValue) ? Math.max(0, currentValue) : 0;
    if (current <= 0) return 0;

    const safeTargets = [];
    targets.forEach((target, index) => {
      let value = Number(target);
      if (!Number.isFinite(value) || value <= 0) {
        value = index === 0 ? 1 : safeTargets[index - 1] + 1;
      }
      if (index > 0 && value <= safeTargets[index - 1]) {
        value = safeTargets[index - 1] + 1;
      }
      safeTargets.push(value);
    });

    const stepCount = safeTargets.length;
    const positions = safeTargets.map((_, index) => this.getBundlePointPosition(index, stepCount));
    const lastTarget = safeTargets[stepCount - 1];
    if (current >= lastTarget) return 100;

    for (let index = 0; index < safeTargets.length; index += 1) {
      const target = safeTargets[index];
      if (current < target) {
        if (index === 0) {
          return Math.max(0, Math.min((current / target) * positions[0], 100));
        }
        const prevTarget = safeTargets[index - 1];
        const startPos = positions[index - 1];
        const endPos = positions[index];
        const ratio = (current - prevTarget) / (target - prevTarget);
        return Math.max(0, Math.min(startPos + ratio * (endPos - startPos), 100));
      }
    }

    return 100;
  }

  getBundlePointPosition(index, stepCount) {
    if (!Number.isFinite(index) || !Number.isFinite(stepCount) || stepCount <= 0) return 0;
    return ((index + 0.5) / stepCount) * 100;
  }

  initTimer() {
    if (!this.timerEl) {
      this.syncStickyTimerFromMain();
      return;
    }
    const cutoff = this.timerEl.dataset.cutoff || '';
    this.cutoffTime = this.parseCutoffTime(cutoff);
    if (!this.cutoffTime) {
      this.timerEl.hidden = true;
      this.syncStickyTimerFromMain();
      return;
    }
    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    if (!this.timerEl || !this.cutoffTime) return;
    const nowParts = this.getZonedParts(new Date(), this.timerTimezone);
    if (!nowParts) {
      this.timerEl.hidden = true;
      this.syncStickyTimerFromMain();
      return;
    }

    const isSunday = nowParts.weekday === 'Sun';
    const nowTs = Date.UTC(nowParts.year, nowParts.month - 1, nowParts.day, nowParts.hour, nowParts.minute, nowParts.second);
    const cutoffTs = Date.UTC(nowParts.year, nowParts.month - 1, nowParts.day, this.cutoffTime.hour, this.cutoffTime.minute, 0);
    const hasMessage = this.timerMessage && this.timerMessage.textContent.trim().length > 0;

    if (isSunday || nowTs >= cutoffTs) {
      if (this.timerCountdown) this.timerCountdown.classList.add('is-hidden');
      if (this.timerMessage) {
        this.timerMessage.classList.toggle('is-hidden', !hasMessage);
      }
      this.timerEl.classList.toggle('is-hidden', !hasMessage);
      this.syncStickyTimerFromMain();
      return;
    }

    this.timerEl.classList.remove('is-hidden');
    if (this.timerCountdown) this.timerCountdown.classList.remove('is-hidden');
    if (this.timerMessage) this.timerMessage.classList.add('is-hidden');

    const diffSeconds = Math.max(0, Math.floor((cutoffTs - nowTs) / 1000));
    const hours = Math.floor(diffSeconds / 3600);
    const minutes = Math.floor((diffSeconds % 3600) / 60);
    const seconds = diffSeconds % 60;
    if (this.timerValue) {
      this.timerValue.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}min ${String(seconds).padStart(2, '0')}sec`;
    }
    this.syncStickyTimerFromMain();
  }

  parseCutoffTime(value) {
    const match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    const hour = Number.parseInt(match[1], 10);
    const minute = Number.parseInt(match[2], 10);
    if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
    return { hour, minute };
  }

  getZonedParts(date, timeZone) {
    try {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        weekday: 'short',
        hour12: false
      });
      const parts = formatter.formatToParts(date);
      const map = {};
      parts.forEach((part) => {
        if (part.type === 'literal') return;
        map[part.type] = part.value;
      });
      return {
        year: Number.parseInt(map.year, 10),
        month: Number.parseInt(map.month, 10),
        day: Number.parseInt(map.day, 10),
        hour: Number.parseInt(map.hour, 10),
        minute: Number.parseInt(map.minute, 10),
        second: Number.parseInt(map.second, 10),
        weekday: map.weekday
      };
    } catch (error) {
      return null;
    }
  }

  onBreakpointChange(event) {
    this.destroySwipers();
    this.initSwipers(event.matches);
    if (this.bundleForm && this.bundleCards?.length) {
      this.applyBundleFilter(this.bundleActiveFilter || 'all', { animate: false });
    }
  }

  initSwipers(isDesktop) {
    if (!this.mainEl || !this.thumbsEl || typeof Swiper === 'undefined') return;

    this.mainSwiper = new Swiper(this.mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      on: {
        slideChange: this.onMainSlideChange
      }
    });

    this.thumbsSwiper = new Swiper(this.thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      direction: isDesktop ? 'vertical' : 'horizontal',
      freeMode: true,
      watchSlidesProgress: true
    });

    this.onMainSlideChange();
  }

  destroySwipers() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }

    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }
  }

  onThumbClick(event) {
    const button = event.target.closest('.main-product__thumb-button');
    if (!button || !this.mainSwiper) return;

    const index = Number.parseInt(button.dataset.slideIndex, 10);
    if (Number.isNaN(index)) return;

    this.mainSwiper.slideTo(index);
  }

  onMainSlideChange() {
    if (!this.mainSwiper) return;

    const activeIndex = this.mainSwiper.realIndex ?? this.mainSwiper.activeIndex ?? 0;

    this.thumbSlides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle('is-active', isActive);
      const button = slide.querySelector('.main-product__thumb-button');
      if (button) {
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      }
    });

    if (this.thumbsSwiper) {
      const thumbIndex = Math.max(activeIndex - 1, 0);
      this.thumbsSwiper.slideTo(thumbIndex);
    }
  }
}

if (!customElements.get('main-product-component')) {
  customElements.define('main-product-component', MainProductComponent);
}
